<template>
    <b-card v-if="previwEmit">
        <div slot="header">
            <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                    <div>
                        <template v-if="typeTicket == 1">
                            <h3><b>Boleta Electrónica</b></h3> 
                        </template>
                        <template v-else>
                            <h3><b>Boleta Contingencia</b></h3>
                        </template>
                    </div>           
                </b-col>
                <b-col ccols="12" sm="6"	md="4"	lg="3"	xl="2">
                    <select class="form-control input-placedark input-dark colorBorde" v-model="tipoOperacion">
                        <option v-for="tipo in listadeoperaciones" :value="tipo.tipo" :key="tipo.tipo">{{ tipo.name }}</option>
                    </select>
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                    <datepicker
                        style="border-radius:4px;border:1px solid #012171"
                        v-model="femision" 
                        :format="customFormatter" 
                        :language="es" 
                        :bootstrap-styling="true" 
                        :disabledDates="diasnopermitidos" 
                        :placeholder="currentdate">
                    </datepicker>
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                   <b-form-select 
                        class="input-placedark input-dark colorBorde" 
                        v-model="typeTicket" 
                        :options="options">
                    </b-form-select> 
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                    <b-input-group>
                        <b-form-checkbox
                            v-model="switchAnticipo"
                            :disabled="disabledAnticipo"
                            class="mx-1 cargaritemsPersonalizado colorBorde">
                            Anticipo
                        </b-form-checkbox>
                        <b-button
                            class="ml-2"
                            :disabled="buttonRegularizacionAnticipos"
                            id="tooltipButton-20"
                            size="sm"
                            variant="success"
                            @click="addAnticipos">
                            Regularización Anticipo
                        </b-button>
                    </b-input-group>    
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2">
                    <select class="custom-select mr-sm-2 input-placedark input-dark colorBorde" v-model="moneda">
                        <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                            {{ moneda.descripcion }}
                        </option>
                    </select>
                </b-col>
            </b-row>
            <b-row align-v="center">
                <b-modal title="Agregar Boletas anticipo" size="lg" centered v-model="modalAnticipos">
                    <div v-if="!cargandoAnticipos">
                        <div class="row">
                            <div class="col-md-12 text-center">
                            <h3>
                                Cargando Boletas con Anticipos
                                <i class="fa fa-spin fa-spinner"></i>
                            </h3>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <b-row>
                            <b-col cols="12">
                                <b-table
                                    responsive
                                    small
                                    :striped="striped"
                                    :outlined="outlined"
                                    :items="docAnticipos"
                                    :fields="docAnticipos_fields"
                                >  
                                    <template striped hover slot="idReceptor razonSocial" slot-scope="row">
                                        {{ row.item.idReceptor }}
                                    </template>
                                    <template striped hover slot="tipoAfectacion" slot-scope="row">
                                        <div v-if="row.item.tipoAfectacion == '10'">Gravado</div>
                                        <div v-else-if="row.item.tipoAfectacion == '20'">Inafecto</div>
                                        <div v-else-if="row.item.tipoAfectacion == '30'">Exonerado</div>
                                        <div v-else>Sin asignar</div>
                                    </template>
                                    <template striped hover slot="montoRegularizado">
                                        <b-form-input
                                                class="input-placedark input-dark"
                                                placeholder="Monto por regularizar"
                                                disabled
                                        ></b-form-input>
                                    </template>
                                    <template striped hover slot="monto" slot-scope="row">
                                        <b-input size="sm" class="descuento text-center"
                                                v-model="row.item.montoAnticipo"
                                        ></b-input>
                                    </template> 
                                    <template striped hover slot="agregar" slot-scope="row">
                                        <b-btn class="btn btn-sm btn-group btn-outline-info" @click="addAnt(row.item, row.index)">
                                            <i class="fa fa-plus"></i>
                                        </b-btn>
                                    </template>                         
                                </b-table>
                            </b-col>
                        </b-row>
                        <b-row>
                        <div class="col-md-6">
                            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                        </div>
                            <div class="col-md-6">
                            <div class="float-right">
                                <b-pagination
                                    size="sm"
                                    :total-rows="total"
                                    v-model="currentPage"
                                    @input="searchAnticipoByRuc"
                                    :per-page="limite"
                                ></b-pagination>
                            </div>
                        </div>
                        </b-row>
                        <hr>
                        <b-row>
                            <b-col cols="4"></b-col>
                            <b-col cols="5">
                            <strong>
                                <u>Resumen de Regularizacion de Anticipo</u>
                            </strong>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                            <ul>
                                <li class="lianticipo" v-for="(item, index) in selectedAnticipos" v-bind:key="item.index">
                                <b-row>
                                    <b-col cols="5"></b-col>
                                    <b-col cols="2">{{ item.serieNumero }}</b-col>
                                    <b-col cols="3" v-if="item.tipoAfectacion == 10">{{ item.montoAnticipado }}</b-col>
                                    <b-col cols="3" v-else-if="item.tipoAfectacion == 30">{{ item.montoAnticipadoExonerado }}</b-col>
                                    <b-col cols="3" v-else-if="item.tipoAfectacion == 20">{{ item.montoAnticipadoInafecto }}</b-col>
                                    <b-col cols="2">
                                    <b-button size="sm" variant="danger" @click="remAnt(item, index)">
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                    </b-col>
                                </b-row>
                                </li>
                            </ul>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row v-if="cargandoAnticipos">
                        <b-col cols="7"></b-col>
                        <b-col cols="2" class="bordesAnticipos">Total anticipo:</b-col>
                        <b-col cols="2" class="bordesAnticipos">{{ accumulateAnticipos() }}</b-col>
                        <b-col cols="1"></b-col>
                    </b-row>
                    <div slot="modal-footer" class="w-100">
                        <b-row>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="9"></b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                            <template v-if="!validateRegularizacion()">
                                <b-button  type="button" variant="primary" @click="sendBoletaAnticipos">
                                    <i class="fa fa-plus"></i> Regularizar 
                                </b-button>
                            </template>
                            </b-col>
                        </b-row>
                    </div>
                </b-modal>
                <!-- fin de anticipo -->
                <!-- inicio modal error -->
                <b-modal v-model="errorboleta" centered size="lg">
                  <div>       
                      <b-row no-gutters>
                        <b-col md="5" class="ml-4">
                          <b-img src="images/error3.png"  height="260%" style="width:90%" ></b-img>
                        </b-col>
                        <b-col md="6">
                          <b-card-body title="Ups! error">
                            <b-card-text>
                               {{error1}} <br>
                               <hr>
                               {{error2}} <br>
                               <hr>
                               {{error3}}
                            </b-card-text>
                          </b-card-body>
                        </b-col>
                      </b-row>
                  </div>
                  <template slot="modal-footer">
                    <b-button variant="danger" @click="errorboletamodal()">Cerrar</b-button>
                  </template>
                </b-modal>
                <!-- fin  modal error -->
            </b-row>   
        </div>
        <template v-if="tipoOperacion == '0101EDU'">
        <b-row  class="mb-2">
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="DNI del Alumno"
                  v-model="dniAlumno"
          ></b-form-input>
        </b-col>
        <b-col cols="12" sm="6" md="4" lg="4" xl="3">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Nombre Completo"
                  v-model="nomApeAlumno"
          ></b-form-input>
        </b-col>
        <!-- <b-col cols="12" sm="6" md="4" lg="4" xl="4">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Dirección del Colegio (Opcional)"
                  v-model="direccionColegio"
          ></b-form-input>
        </b-col> -->
        <b-col cols="12" sm="6" md="4" lg="4" xl="3">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Dirección Domicilio Alumno (Opcional)"
                  v-model="direccionDomAlumno"
          ></b-form-input>
        </b-col>
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Aula del Alumno (Opcional)"
                  v-model="aula">
          </b-form-input>
        </b-col>
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
          <b-form-input
                  class="input-placedark input-dark colorBorde"
                  placeholder="Grado Y Sección (Opcional)"
                  v-model="gradoYseccion"
          ></b-form-input>
        </b-col>
        <!-- <b-col cols="12" sm="6" md="4" lg="4" xl="3">
          <b-input-group size="md" :prepend="prependUbigeoOrigen">
            <b-form-input
                    class="input-placedark input-dark colorBorde"
                    placeholder="Ubigeo Domicilio Alumno"
                    v-model="ubigeoOrigenDom"
            ></b-form-input>
              <b-input-group-text class="colorBorde" slot="append">
                    <b-button @click="ubigeoOrigenDomicilio()" size="sm" variant="primary" class="sinresultados mr-1" title="Buscar Ubigeo">
                      <i class="fas fa-search"></i>
                    </b-button>
              </b-input-group-text>
          </b-input-group>
        </b-col> -->
      </b-row>
      <!-- <b-row class="mb-2">
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
          <b-input-group size="md" :prepend="prependUbigeoDestino">
            <b-form-input
                    class="input-placedark input-dark colorBorde"
                    placeholder="Ubigeo del Colegio"
                    v-model="ubigeoDestinoDom"
            ></b-form-input>
          </b-input-group>
        </b-col>
        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
        <datepicker
              style="border-radius:4px;border:1px solid #012171"
              v-model="periodoAcademido"
              :format="customFormatter"
              :language="es"
              :bootstrap-styling="true"
              placeholder="Fecha Inicio Académido">
            </datepicker>
          </b-col>
      </b-row> -->
      <hr/>
    </template>
    <b-modal v-model="modalUbigeoOrigen" size="lg" centered>
        <h3>Buscar Ubigeo del Domicilio</h3>
        <b-row>
          <b-col cols="3">
            <template>
              <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoOrigen">
                <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
              </select>
            </template>
                    </b-col>
                    <b-col cols="3">
                        <template>
                            <div v-if="!provOrigen">
                                <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona una Provincia...">
                                </b-form-input>
                            </div>
                            <div v-else-if="provOrigenCargando">
                              <pulse-loader></pulse-loader>
                            </div>
                            <div v-else>
                                <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoOrigen">
                                    <option v-for="provincia in listProvinceOrigen.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                                </select>
                            </div>
                        </template>
                    </b-col>
                    <b-col cols="3">
                        <template>
                            <div v-if="!distOrigen">
                                <b-form-input 
                                    type="text"
                                    disabled
                                    placeholder="Selecciona un Distrito...">
                                </b-form-input>
                            </div>
                            <div v-else-if="distOrigenCargando">
                              <pulse-loader></pulse-loader>
                            </div>
                            <div v-else>
                                <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoOrigen">
                                    <option v-for="distrito in listDistrictOrigen.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                                </select>
                            </div>
                        </template>
                    </b-col>
        </b-row>
      <hr/>  
      <h3>Buscar Ubigeo del Colegio</h3>
      <b-row>
        <b-col cols="3">
                    <template>
                        <select class="custom-select mr-sm-2" v-model="departamentoSeleccionadoUbigeoDestino">
                            <option v-for="departamento in listDepartamento" :value="departamento.codDepartamento" :key="departamento.codDepartamento">{{ departamento.nombre }}</option>
                        </select>
                    </template>
                </b-col>
                <b-col cols="3">
                    <template>
                        <div v-if="!provDestino">
                            <b-form-input 
                                type="text"
                                disabled
                                placeholder="Selecciona un Departamento...">
                            </b-form-input>
                        </div>
                        <div v-else-if="provDestinoCargando">
                            <pulse-loader></pulse-loader>
                        </div>
                        <div v-else>
                            <select class="custom-select mr-sm-2" v-model="provinciaSeleccionadaUbigeoDestino">
                                <option v-for="provincia in listProvinceDestino.Departments" :value="provincia.codProvincia" :key="provincia.codProvincia">{{ provincia.nombre }}</option>
                            </select>
                        </div>
                    </template>
                </b-col>
                <b-col cols="3">
                    <template>
                        <div v-if="!distDestino">
                            <b-form-input 
                                type="text"
                                disabled
                                placeholder="Selecciona un Departamento...">
                            </b-form-input>
                        </div>
                        <div v-else-if="distDestinoCargando">
                            <pulse-loader></pulse-loader>
                        </div>
                        <div v-else>
                            <select class="custom-select mr-sm-2" v-model="distritoSeleccionadoUbigeoDestino">
                                <option v-for="distrito in listDistrictDestino.Departments" :value="distrito" :key="distrito.codDistrito">{{ distrito.nombre }}</option>
                            </select>
                        </div>
                    </template>
                </b-col>
      </b-row>
    </b-modal>
        <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">        
                <b-row>                       
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2" class="pr-1">
                        <select class="custom-select mr-sm-2 input-placedark input-dark colorBorde" id="inlineFormCustomSelect" v-model="tipoDocumento">                       
                            <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                                {{ tipodocumento.nombre }}
                            </option>
                        </select> 
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2" class="pl-1 pr-1">
                        <template v-if="tipoDocumento != 0 || tiporeceivers">
                            <b-input-group>
                                <b-form-input 
                                    class="input-placedark input-dark colorBorde " 
                                    placeholder="Buscar Documento"
                                    type="text"
                                    maxlength="11"
                                    :disabled="tipoDocumento==0"
                                    v-model="receptor.numero"
                                    @change="getReceivers(1)">
                                </b-form-input>
                             </b-input-group> 
                        </template>
                        <template v-else>
                            <b-form-input class="colorBorde" placeholder="Buscar Documento" disabled></b-form-input>                          
                        </template> 

                        <template v-if="cargandoreceptor">
                                <b-list-group-item>Buscando... <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                        </template>
                        <b-list-group v-if="listarec" class="searcher-field">
                            <template v-for="(item, index) in listaReceptores">
                                <b-list-group-item 
                                    :key="index" 
                                    @click="setReceiver(item)" 
                                    class="searcher-result">
                                    {{item.idReceptor + ' - ' + item.razonSocial}}
                                </b-list-group-item>
                            </template> 
                        </b-list-group>
                        <b-list-group v-if="mostrardni" class="searcher-field">                                
                            <template >
                                <b-list-group-item  @click="setReceiverdni(listadni)" class="searcher-result">{{listadni.nombre + ' -- ' + listadni.dni}}</b-list-group-item>
                            </template> 
                        </b-list-group>         
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2" v-if="tipoDocumento != '0'">
                        <b-form-input 
                            class="input-placedark input-dark colorBorde" 
                            size="md" 
                            type="text" 
                            v-model="receptor.razonSocial" 
                            :value="receptor.razonSocial" 
                            @input="receptor.razonSocial = $event.toUpperCase()"
                            placeholder="Razón Social">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2" v-else class="pl-1 pr-1">
                        <b-input 
                            v-model="receptor.razonSocial"  
                            @keyup.enter="getReceivers(2)" 
                            placeholder="Buscar Razón Social"
                            @input="receptor.razonSocial = $event.toUpperCase()"
                            class="colorBorde input-placedark input-dark">
                        </b-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="4" class="pl-1 pr-1">
                        <b-row>
                            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                                <b-input-group>
                                    <b-form-input 
                                        class="input-placedark input-dark colorBorde" 
                                        size="md" 
                                        type="text" 
                                        v-model="receptor.direccion" 
                                        :value="receptor.direccion" 
                                        placeholder="Dirección">
                                    </b-form-input>
                                    <b-input-group-text class="colorBorde" slot="append">
                                        <button 
                                            class="btn btn-warning btn-sm sinresultados"
                                            @click="changeDirection()">
                                            <i class="fa fa-list"></i>
                                        </button>
                                    </b-input-group-text>
                                </b-input-group>
                                <template v-if="verDirecciones">
                                    <template v-for="(item, index) in direcciones" class="buscarRuc">
                                        <b-list-group-item :key="index" @click="setDirection(item)" class="searcher-result">
                                        {{item.direccion}}
                                        </b-list-group-item>
                                    </template>
                                </template> 
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2" class="pl-1">
                        <b-row>
                            <template v-if="typeTicket == 1">
                                <b-col> 
                                    <b-input-group>
                                        <template v-if="seriesCargadas">
                                            <b-button size="md" variant="secondary" outline-success>
                                                Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <select class="form-control input-placedark input-dark colorBorde" v-model="indexSerie">
                                                <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                                            </select>
                                        </template>
                                    </b-input-group>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col>                                   
                                    <input v-model="seriecon" maxlength="4" type="text" class="form-control  input-requerido colorBorde" placeholder="Serie (*)">
                                    <!-- <small v-if="checkseriecon" class="form-text text-muted"><span class="text-danger">{{ responsecheckseriecon }}</span></small>   -->
                                </b-col>
                                <b-col>                             
                                    <input v-model="numero" minlength="1" type="text" class="form-control colorBorde input-placedark input-placedark" placeholder="Numero">                                   
                                </b-col>
                            </template>                                
                        </b-row>                        
                    </b-col>
                </b-row>
            </b-col>
        </b-row><br>
        <b-row>
            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="1" class="pr-1">
                <b-form-input 
                    v-model="cantidad" 
                    class="form-control input-dark input-placedark colorBorde" 
                    placeholder="Cantidad (*)" 
                    required/>
                <small v-if="checkcantidad" class="form-text text-muted"><span class="text-danger">{{ responsecheckcantidad }}</span></small>            
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2" class="pr-1 pl-1">
                <select class="custom-select mr-sm-2 input-placedark input-dark colorBorde" id="inlineFormCustomSelect" v-model="unidadMedidaCantidad">                       
                    <option :value="unidad.codigo" v-for="unidad in unidades" v-bind:key="unidad.id">
                        {{ unidad.descripcion }}
                    </option>
                </select>                    
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2" class="pl-1 pr-1">
                <b-input-group>
                    <b-form-input 
                        class="input-placedark input-dark colorBorde" 
                        placeholder="C. Prod." 
                        maxlength="30" 
                        v-model="codigoProducto" 
                        @change="getReceiversProductCode">
                    </b-form-input>
                </b-input-group>
                <template v-if="cargandoCodBarras">
                    <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                </template>
                <b-list-group v-if="listarecProduct" class="searcher-field">
                <!-- <b-list-group-item v-if="norecProduct">No hay Receptores con ese número</b-list-group-item>                                 
                <template v-for="(item, index) in listaReceptoresProductCode">
                    <b-list-group-item :key="index" @click="setReceiverProductCode(item)" class="searcher-result">{{item.codigo + ' - ' + item.descripcion}}</b-list-group-item>
                </template> -->
                <table v-if="listaReceptoresProductCode.length > 0" class="searcher-result3">
                <tr class="centrarTitulo tablaborde">
                  <th style="width:10%;">Código</th>
                  <th style="width:50%;">Productos</th>
                  <th style="width:8%;">Precio</th>
                  <th style="width:5%;">Costo</th>
                  <th style="width:7%;">Stock</th>
                </tr>
              </table>
            <template v-for="(item, index) in listaReceptoresProductCode">
              <table  
                @click="setReceiverProductCode(item)" 
                class="searcher-result2" 
                :key="index">  
                <tr>
                  <td style="width:10%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                  <td style="width:50%;" class="tablaborde ">{{item.descripcion.toUpperCase()}}</td>
                  <td style="width:8%;" class="tablaborde centrarTitulo">{{item.precioUnitario}}</td>
                  <td style="width:5%;color:red" class="tablaborde centrarTitulo">{{item.precioCosto}}</td>
                  <td style="width:7%;" class="tablaborde centrarTitulo">{{item.stock}}</td>
                </tr>
              </table>
              </template>
                </b-list-group>                            
            </b-col>
            <!-- <b-col cols="12" sm="6"	md="4"	lg="3"	xl="2" class="pl-1 pr-1"> -->
                <!-- <b-input-group>
                    <template> 
                        <b-form-input 
                            :placeholder="placeholdercodigo" 
                            maxlength="8" 
                            v-model="codigoSunatBarras" 
                            @change="getReceiversCodeBarrasSunat" 
                            class="input-placedark input-dark input-placedark colorBorde">
                        </b-form-input>
                    </template>       
                </b-input-group> -->
                <!-- <template v-if="cargandoBarrasSunat">
                    <b-list-group-item> Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                </template>
                <b-list-group 
                    v-if="listarecProductBarrasSunat" 
                    class="searcher-field input-placedark input-dark">
                <b-list-group-item v-if="norecProductBarrasSunat">No hay Receptores con ese número</b-list-group-item>                                 
                <template v-for="(item, index) in listaReceptoresCodeBarrasSunat">
                    <b-list-group-item 
                        :key="index" 
                        @click="setReceiverCodeBarrasSunat(item)" 
                        class="searcher-result ">
                        {{item.codigo + ' - ' + item.descripcion}}
                    </b-list-group-item>
                </template>
                </b-list-group>                             -->
            <!-- </b-col> -->
            <b-col cols="12" sm="12"	md="8"	lg="12"	xl="7" class="pl-1">
                <b-input-group>
                    <b-form-input 
                        placeholder="Descripción Producto" 
                        maxlength="500" 
                        v-model="descripcion" 
                        @keydown="tecla"
                        class="input-placedark input-dark colorBorde" 
                        type="text">
                    </b-form-input>
                    <b-input-group-text class="colorBorde" slot="append">
                        <button 
                            class="btn btn-warning btn-sm sinresultados" 
                            @click="cerrarresultados">
                            <i class="fa fa-times"></i>
                        </button>
                        <b-button  
                            variant="primary" 
                            class="sinresultados ml-1" 
                            size="sm" 
                            @click="busquedaProductos()">
                            <i class="fa fa-list"></i>
                        </b-button>
                    </b-input-group-text>
                </b-input-group>
                <template v-if="cargandoDescription">
                    <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                </template>
                <b-list-group v-if="listades" class="searcher-field">
                    <template v-if="!nuevaBusqueda">
                        <table v-if="listaDescription.length > 0" class="searcher-result3">
                        <tr class="centrarTitulo tablaborde">
                            <th style="width:50%;">Productos</th>
                            <th style="width:8%;">Precio</th>
                            <th style="width:5%;">Costo</th>
                            <th style="width:10%;">Código</th>
                        </tr>
                        </table>
                        <template v-for="(item, index) in opcionesOrdenadas">
                        <table
                            @click="agregarItem(item)" 
                            class="searcher-result2" 
                            :key="index">  
                            <tr>
                            <td style="width:50%;" class="tablaborde ">{{item.descripcion.toUpperCase()}}</td>
                            <td style="width:8%;" class="tablaborde centrarTitulo">{{item.precioUnitario}}</td>
                            <td style="width:5%;color:red" class="tablaborde centrarTitulo">{{item.precioCosto}}</td>
                            <td style="width:10%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                            </tr>
                        </table>
                        </template>
                    </template>
                </b-list-group>
                <template>
                    <div v-if="cargandoInformacion">
                        <b-list-group-item>Cargando Informacion <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                    </div>
                </template>                      
            </b-col>
        </b-row><br>        
        <b-row>   
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="9">
                <b-row>
                    <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2" class="pr-1">
                        <b-form-input 
                            v-if="!vunitario" 
                            v-model="precioVentaUnitario" 
                            class="input-dark intpu-placedark colorBorde" 
                            placeholder="Precio Unitario (con IGV)" 
                            @keyup.enter="addItem()" 
                            required/>
                        <b-form-input 
                            v-else 
                            v-model="precioVentaUnitario" 
                            class="input-dark input-placedark colorBorde" 
                            placeholder="Precio Unitario (con IGV)" 
                            required 
                            disabled/>
                        <small v-if="checkprecioventaunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckprecioventaunitario }}</span></small>
                    </b-col>
                    <b-col cols="12" sm="4"	md="3"	lg="2"	xl="2" class="pl-1 pr-1">
                        <b-form-input
                            v-if="vunitario" 
                            type="number" 
                            min="0.0" 
                            step="0.01" 
                            v-model="valorUnitario" 
                            class="input-placedark input-dark colorBorde"
                            placeholder="Valor Unitario (Sin IGV)" 
                            required/>
                        <b-form-input 
                            v-else 
                            type="number"
                            min="0.0" 
                            step="0.01" 
                            v-model="valorUnitario" 
                            class="input-placedark input-dark colorBorde" 
                            placeholder="Valor Unitario (Sin IGV)" 
                            required 
                            disabled/>
                        <small v-if="checkvalorunitario" class="form-text text-muted"><span class="text-danger">{{ responsecheckvalorunitario }}</span></small>
                    </b-col>
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="1" class="botondescuento">
                        <b-form-checkbox  v-model="descuento">Dscto</b-form-checkbox>
                    </b-col>
                    <b-col cols="12" sm="4"	md="3"	lg="3"	xl="2" class="pl-0">                               
                        <b-input-group v-if="!descuento" class="checkdescuentoitem">
                            <b-form-input class="colorBorde" v-model="descuentoItemMonto"/>
                            <b-input-group-text slot="prepend" class="colorBorde">
                                S/
                            </b-input-group-text>
                        </b-input-group>                                
                        <b-input-group v-else class="checkdescuentoitem">
                            <b-form-input class="colorBorde" v-model="descuentoItemPorcentaje"></b-form-input>
                            <b-input-group-text class="colorBorde" slot="append">
                                %                  
                            </b-input-group-text>
                        </b-input-group>
                    </b-col>
                    <b-col cols="12" sm="6"	md="3"	lg="2"	xl="2" class="pl-1 pr-1">
                        <b-form-input 
                            v-if="tipoOperacion == '0200'" 
                            disabled 
                            value="Exportación">
                        </b-form-input>
                        <b-form-input 
                            v-if="tipoOperacion == '0101EDU'" 
                            class="custom-select input-dark colorBorde" 
                            disabled 
                            value="Inafecto">
                        </b-form-input>
                        <select v-else class="custom-select mr-sm-2 input-placedark input-dark colorBorde" v-model="especificacionIgv" :disabled="vunitario == true">
                            <option :value="afec.id" v-for="afec in listaafectacion" v-bind:key="afec.id">
                                {{ afec.descripcion }}
                            </option>
                        </select>
                    </b-col>
                    <b-col v-if="!ventaGratuita" cols="12" sm="6"	md="3"	lg="3"	xl="3" class="pl-1">
                        <b-form-input class="colorBorde" disabled value="Operación Onerosa"></b-form-input>
                    </b-col>
                    <b-col v-else cols="12" sm="6"	md="3"	lg="3"	xl="3">
                        <b-form-input 
                            v-if="tipoOperacion == '0200'" 
                            disabled 
                            value="Bienes"
                            >
                        </b-form-input>
                        <select v-else class="custom-select mr-sm-2 input-placedark input-dark colorBorde" v-model="especificacion">
                            <option :value="espec" v-for="espec in Especificacion" v-bind:key="espec.id">
                                {{ espec.descripcion }}
                            </option>
                        </select>
                    </b-col>
                </b-row><br><br>
                <b-row>
                    <b-col cols="12" sm="8"	md="8"	lg="8"	xl="8" class="ml-5 text-center buttonagregar">
                        <template v-if="!setUpdateItem">
                            <button class="btn btn-primary btnagregarstyle" v-if="validateFields()" @click="addItem()"><i class="fa fa-plus"></i> Agregar</button>
                            <button class="btn btn-secondary btnagregarstyle" disabled v-else><i class="fa fa-plus"></i> Agregar</button>
                        </template>
                        <template v-else>
                            <button class="btn btn-warning" @click="executeUpdate()"><i class="fa fa-plus"></i> Actualizar</button>
                        </template>
                    </b-col>
                    <!-- importar items -->
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="3" class="mover">
                        <!-- <b-form-file v-model="doc" :state="Boolean(doc)" @change="onChange" placeholder="Documento" />  -->
                        <div class="upload-btn-wrapper">
                          <b-button class="estilo" v-model="doc" :state="Boolean(doc)"><i class="fas fa-upload"></i> Items</b-button>
                          <input  type="file" @change="onChange" name="myfile" />
                        </div>
                        <xlsx-read :file="file">                       
                            <xlsx-json>
                            <template #default="{collection}">
                                <div style="display:none;">
                                {{ coleccion=collection }}
                                </div>
                            </template>
                            </xlsx-json>
                        </xlsx-read>
                    </b-col>
                    <!-- <b-col cols="1" class="mover">
                        <b-button :disabled="borraritem" @click="limpiarExcel()" variant="danger">Borrar</b-button>
                    </b-col> -->
                    <import :item="item" :itemsEX="itemsEX" :itemsEXz="itemsEXz" :action="action" @totalitems="totalitems" :igvGlobal="igvGlobal"></import>
                    <!-- importar items -->
                </b-row>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="3"	xl="1" class="pl-0 ">
                <b-form-input 
                    :placeholder="placeholdercodigo" 
                    maxlength="8" 
                    v-model="codigoSunatBarras" 
                    @change="getReceiversCodeBarrasSunat" 
                    class="input-placedark input-dark input-placedark colorBorde">
                </b-form-input>
            </b-col>
            <b-col style="background-color:#ffb80e;border-radius:20px" class="pt-2 pb-0 mb-2" cols="12" sm="12" md="12" lg="12" xl="2">
                    <!-- <span class="titulo-opitem"><strong> Operaciones Adicionales </strong></span>
                    <br> -->
                    <b-form-checkbox v-model="vunitario">Usar valor unitario</b-form-checkbox>
                    <b-form-checkbox v-model="servicio">Servicio</b-form-checkbox>
                    <!-- <b-form-checkbox v-model="vbarras">C. Barras</b-form-checkbox> -->
                    <b-form-checkbox v-model="ventaGratuita">Venta Gratuita</b-form-checkbox>
                    <b-form-checkbox v-model="icbper">ICBPER</b-form-checkbox>
                    <div style="float:left">
                        <b-form-checkbox 
                            v-model="isc">
                            ISC
                        </b-form-checkbox>
                    </div>
                    <div v-if="isc">
                        <b-form-select 
                            class="ml-3 mb-2" 
                            style="width:40%;float:left" 
                            v-model="selectedISC" 
                            :options="optionsISC" 
                            size="sm">
                        </b-form-select>
                    </div>            
                    <div class="mb-2" style="float:left" v-if="selectedISC == 1 && isc == true">
                        <template v-if="cuadroISC">
                        <b-input-group >
                            <template #append>
                                <b-input-group-text style="height:30px">%</b-input-group-text>
                            </template>
                            <b-form-input 
                                v-model="montoISC" 
                                @keyup.enter="valorUnitIsc()" 
                                type="number" 
                                style="height:30px;width:100px;margin-left:20px" 
                                autofocus >
                            </b-form-input>
                        </b-input-group>
                        </template>
                        <template v-else-if="flechaISC">
                            <b-button class="ml-2"  @click="mostrarISC" size="sm" variant="light"><i class="fas fa-arrow-right"></i></b-button>                 
                        </template>
                    </div>
                    <div class="mb-2" style="float:left" v-if="selectedISC == 2 && isc == true">
                        <template v-if="cuadroISC">
                            <b-input-group >
                                <template #append>
                                    <b-input-group-text style="height:30px">S/</b-input-group-text>
                                </template>
                                <b-form-input 
                                    v-model="montoISC"
                                    @keyup.enter="valorUnitIsc()" 
                                    type="number" 
                                    style="height:30px;width:100px;margin-left:20px" 
                                    autofocus >
                                </b-form-input>
                            </b-input-group>
                        </template>
                        <template v-else-if="flechaISC">
                            <b-button class="ml-2"  @click="mostrarISC" size="sm" variant="light"><i class="fas fa-arrow-right"></i></b-button>                 
                        </template>
                    </div>
                    <div class="mt-2 mb-2" style="float:left;width:100%" v-if="selectedISC == 3 && isc == true">
                        <template v-if="cuadroISC">
                        <div style="width:49%;float:left">
                            <b-input-group >
                                <template #append>
                                    <b-input-group-text style="height:30px">S/</b-input-group-text>
                                </template>
                                <b-form-input 
                                    v-model="montoISC" 
                                    type="number" 
                                    style="height:30px" 
                                    autofocus >
                                </b-form-input>
                            </b-input-group>
                        </div>
                        <div style="width:49%;float:right">
                            <b-input-group >
                                <template #append>
                                    <b-input-group-text style="height:30px">%</b-input-group-text>
                                </template>
                                <b-form-input 
                                    v-model="porcentajeISC" 
                                    @keyup.enter="valorUnitIsc()" 
                                    type="number" 
                                    style="height:30px">
                                </b-form-input>
                            </b-input-group>
                        </div>             
                        </template>
                        <template v-else-if="flechaISC">
                            <b-button class="ml-2"  @click="mostrarISC" size="sm" variant="light"><i class="fas fa-arrow-right"></i></b-button>                 
                        </template>
                    </div>
            </b-col>
        </b-row>
        <b-modal scrollable title="Busqueda de productos" size="xl" v-model="searchItems">
            <div v-if="mostrarListaProduc">
                <div align="center" class="mb-5">
                    <h3><i class="fas fa-spin fa-spinner"></i><strong>Cargando...</strong></h3> 
                </div>
            </div>
            <b-table
                    v-else
                    hover
                    outlined
                    small
                    :items="ListProductos" 
                    :fields="List_Productos">
                    <template slot="codigo" slot-scope="row">
                        {{row.item.codigo}}
                    </template>
                    <template slot="precioUnitario" slot-scope="row">
                        <b-form-input style="color:black;border-color:black" v-model="row.item.precioUnitario" type="number"></b-form-input>
                    </template>
                    <template slot="precioCosto" slot-scope="row">
                        <div v-if="row.item.precioCosto == null">
                        0.00
                        </div>
                        <div v-else>{{row.item.precioCosto}}</div>
                    </template>
                    <template slot="stock" slot-scope="row">
                        <div v-if="row.item.stock < 0" style="color:red"><b>{{row.item.stock}}</b></div>
                        <div v-else style="color:green"><b>{{row.item.stock}}</b></div>
                    </template>
                    <template slot="cantidad" slot-scope="row">
                        <b-form-input style="color:black;border-color:black" v-model="row.item.cantidad" placeholder="0" type="number"></b-form-input>
                    </template>
                    <template slot="accion" slot-scope="row">
                        <b-button title="Agregar" variant="success" @click="addUnidad(row.item)" ><i class="fa fa-shopping-basket fa-lg"></i></b-button>
                    </template>
            </b-table>        
             <div slot="modal-header" class="w-100">
                 <b-row>
                    <b-col cols="1" class="mt-2">
                        <label>B&uacute;squeda:</label>        
                    </b-col>
                    <b-col cols="6">
                        <b-form-input style="color:black;border-color:black" v-model="descripcion"  @keyup.enter="search()" placeholder="Descripción"></b-form-input>
                    </b-col>
                    <b-col cols="1">
                        <b-button class="" variant="outline-primary"  @click="search()" title="Buscar"><i class="fas fa-search"></i></b-button>
                    </b-col>
                    <b-col cols="2">
                         <b-button class="" variant="outline-primary" @click="cargarItems()" title="Agregar">Agregar Todo <i class="fas fa-plus"></i></b-button>
                    </b-col>
                </b-row>
            </div>
            <template  slot="modal-footer">
                <div class="w-100">
                <b-row>
                    <b-col cols="1">
                    <p class="float-left mt-2">Código:</p>
                    </b-col>
                    <b-col cols="6" >
                    <b-form-input style="color:black;border-color:black" placeholder="Búsqueda por Código" v-model="codDescripcion" @keyup.enter="searchCodigo()" autofocus></b-form-input>
                    </b-col>
                    <b-col cols="4"></b-col>
                    <b-col cols="1">
                    <b-button variant="outline-primary" @click="closeSearchItem()" title="Salir">Cerrar</b-button>
                    </b-col>
                </b-row>
                </div>
            </template>
        </b-modal>
        <!-- importando items -->
        <!-- <import-items :item="item" :action="action" @totalitems="totalitems"></import-items> -->
        <!-- fin importando items -->
        <br>
        <b-table 
            responsive 
            :small="small"
            :items="items"
            :fields="items_fields"
            >
            <template slot="tieneID" slot-scope="row">
                <template v-if="row.item.idProducto !='-' && row.item.idProducto !='' && row.item.idProducto !=null ">
                    <i title="contiene idProducto" style="color:skyblue" class="fas fa-check"></i>
                </template>
            </template>
            <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
            <template slot="stock" slot-scope="row">
                <template v-if="row.item.stock ==''">
                    <i class="fa fa-spin fa-spinner"></i>
                </template>
                <template   v-else>
                <div v-if="row.item.stock < 0" style="color:red"><b>{{row.item.stock}}</b></div>
                <div v-else style="color:green"><b>{{row.item.stock}}</b></div>
            </template>
            </template>
            <template slot="descripcion" slot-scope="row">
            <b-form-textarea
              id="textarea"
              v-model="row.item.descripcion"
              placeholder="Enter something..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </template>
            <template slot="precioUni" slot-scope="row">
                <template v-if="row.item.adicional && row.item.adicional.precioVentaUni" >
                    {{row.item.adicional.precioVentaUni}}
                </template>
                <template v-else-if="row.item.precioVentaUnitario">
                    {{row.item.precioVentaUnitario}}
                </template>
            </template>
            <template slot="descuentoUni" slot-scope="row">
                <template v-if="row.item.adicional.indicardorDsct == '01'">
                    S/ {{row.item.adicional.dsctSoles}}
                </template>
                <template v-else-if="row.item.adicional.indicardorDsct == '02'">
                    {{row.item.adicional.dsctPorcentaje}} %
                </template>
                <template v-else>
                    {{0.00}}
                </template>
            </template>
            <template slot="valorVentaVista" slot-scope="row">
                <template v-if="row.item.valorVentaVista">
                    {{row.item.valorVentaVista}}
                </template>
                <template v-else-if="row.item.valorVenta">
                    {{row.item.valorVenta}}
                </template>
            </template>
            <template slot="precioT" slot-scope="row">
                {{(parseFloat(row.item.montoTotalImpuestosItem) + parseFloat(row.item.valorVenta)).toFixed(2)}}
                <!-- {{(parseFloat(row.item.cantidad) * row.item.adicional.precioVentaUni).toFixed(2)}} -->
            </template>
            <template slot="acciones" slot-scope="row">
                <b-row>
                    <button class="btn btn-sm btn-group btn-outline-primary acciones-espacio" @click.prevent="updateItem(row.index, row.item)"><i class="fa fa-edit primary"></i></button>
                    <button class="btn btn-sm btn-group btn-outline-danger" @click.prevent="deleteItem(row.index)"><i class="fa fa-trash danger"></i></button>
                </b-row>
            </template>
        </b-table>
        <hr>
        <b-row>
            <b-col cols="12" sm="12"	md="6"	lg="7"	xl="8">
                <div>
                    <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="4">
                        <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                            <option :value="fpago" v-for="fpago in formaPago" v-bind:key="fpago.codigo">
                            {{ fpago.nombre }}
                            </option>
                        </select>
                        </b-col>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="4">
                            <b-form-group
                                label-for="input_seriedeguia"
                                :invalid-feedback="invalidFeedbackOrdenCompra"
                                :valid-feedback="validFeedbackOrdenCompra"
                                :state="stateOrdenCompra">
                                <b-input-group size="md">
                                    <b-form-input :value="ordenCompra"
                                    required
                                    @input="ordenCompra = $event.toUpperCase()"
                                    v-model="ordenCompra"
                                    maxlength="20"
                                    class="form-control input-placedark input-dark"
                                    type="text"
                                    id="input_ordendecompra"
                                    :state="stateOrdenCompra"
                                    placeholder="Orden de Compra">
                                    </b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="4">
                    <datepicker class="input-placedark input-dark" v-model="fvencimiento" :language="es" :format="customFormatter" :bootstrap-styling="true" placeholder="Fecha de Vencimiento"></datepicker>
                    </b-col>
                    </b-row>
                    </div>
                    <b-row class="mb-2"> 
                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Pago con Yape" class="formasPagosImg" src="images/yape.png" @click="pagosImg(1)"><b-badge v-if="colorPago1" style="color:green">Yape</b-badge><p v-else>Yape</p></b-col>
                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Pago con Plin" class="formasPagosImg" src="images/plin.png" @click="pagosImg(2)"><b-badge v-if="colorPago2" style="color:green">Plin</b-badge><p v-else>Plin</p></b-col>
                        <!-- <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Pago A Crédito" class="formasPagosImg" src="images/Acredito.png" @click="pagosImg(3)"><b-badge v-if="colorPago3" style="color:green">A crédito</b-badge><p v-else>A crédito</p></b-col> -->
                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="T.Débito" class="formasPagosImg" src="images/tDebito.png" @click="pagosImg(4)"><b-badge v-if="colorPago4" style="color:green">T.Débito</b-badge><p v-else>T.Débito</p></b-col>
                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Pago Efectivo" class="formasPagosImg" src="images/efectivo1.png" @click="pagosImg(5)"><b-badge v-if="colorPago5" style="color:green">Efectivo</b-badge><p v-else>Efectivo</p></b-col>
                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="T.Crédito" class="formasPagosImg" src="images/tCredito.png" @click="pagosImg(6)"><b-badge v-if="colorPago6" style="color:green">T.Crédito</b-badge><p v-else>T.Crédito</p></b-col>
                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Depósito en Cuenta" class="formasPagosImg" src="images/depositoCuenta.png" @click="pagosImg(7)"><b-badge v-if="colorPago7" style="color:green">Déposito Cuenta</b-badge><p v-else>Déposito Cuenta</p></b-col>
                        <b-col cols="4"	sm="2"	md="2"	lg="2"	xl="1"><img title="Transferencia Bancos" class="formasPagosImg" src="images/transBancos.png" @click="pagosImg(8)"><b-badge v-if="colorPago8" style="color:green">Trans.Fondos</b-badge><p v-else>Trans. Fondos</p></b-col>
                    </b-row> 
                <div>
                    <b-btn block v-b-toggle.relacionadas class="m-1 colorestelemovil">Guias Relacionadas</b-btn>
                    <b-collapse id="relacionadas">
                        <b-card>
                            <b-row>
                                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                    <b-form-group
                                        label-for="input_seriedeguia"
                                        :invalid-feedback="invalidFeedbackSerieGuia"
                                        :valid-feedback="validFeedbackSerieGuia"
                                        :state="stateSerieGuia">
                                        <b-input-group size="md">
                                            <b-form-input :value="seriedeguia" 
                                                required @input="seriedeguia = $event.toUpperCase()" 
                                                v-model="seriedeguia" 
                                                minlength="4" 
                                                maxlength="4" 
                                                class="form-control input-placedark input-dark" 
                                                type="text" 
                                                id="input_seriedeguia" 
                                                :state="stateSerieGuia" 
                                                placeholder="Serie">
                                            </b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                    <b-form-input v-model="numerodeguia" class="form-control input-placedark input-dark" placeholder="Numero" required/>
                                </b-col>
                                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                                    <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="tipodeguia">
                                        <option :value="tipo.codigo" v-for="tipo in tiposGuia" v-bind:key="tipo.codigo">
                                            {{ tipo.nombre }}
                                        </option>
                                    </select>
                                </b-col>
                                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                                    <button v-if="validateFieldsGuia()" class="btn btn-primary" @click="addGuia"><i class="fa fa-plus"></i> Agregar</button>
                                    <button v-else class="btn btn-secondary" disabled><i class="fa fa-plus"></i> Agregar</button>
                                     <input type="file" id="upload" @change="onChange2" hidden/>
                                    <label class="lab" title="Subir Guias" for="upload"><i class="fas fa-upload"></i></label>
                                    <xlsx-read :file="guiasdoc">                       
                                        <xlsx-json>
                                            <template #default="{collection}">
                                                <div style="display:none;">
                                                {{ guiasmasiva=collection }}
                                                </div>
                                            </template>
                                        </xlsx-json>
                                    </xlsx-read>
                                    <masiva-guia :reciveitem="pasandoGuias" :accion="accion" @totalitems2="totalitems2"></masiva-guia>
                                </b-col>
                            </b-row>
                            <div class="row">
                                <b-table striped hover :items="items_guias" :fields="fields_guias">
                                    <template slot="tipoGuia2" slot-scope="row">
                                        <template v-if="row.item.tipoGuia == 1 || row.item.tipoGuia == 'Guia Remision Remitente'">Guia Remision Remitente</template>
                                        <template v-else-if="row.item.tipoGuia == 2 || row.item.tipoGuia == 'Guia Remision Transportista' ">Guia Remision Transportista</template>
                                    </template>
                                    <template striped hover slot="acciones" slot-scope="row">
                                        <b-button-group>
                                            <b-button variant="danger" title="Eliminar Guia" @click="deleteGuia(row.index)"><i class="fa fa-trash"></i></b-button>
                                        </b-button-group>
                                    </template>
                                </b-table>
                            </div>
                        </b-card>  
                    </b-collapse>
                </div>
                <div>
                    <b-btn block v-b-toggle.adicionales class="m-1 colorestelemovil">Datos Adicionales</b-btn>
                    <b-collapse id="adicionales">
                        <b-card>
                            <b-row>
                                <b-col cols="12" sm="12"	md="12"	lg="4"	xl="5">
                                    <input type="text" placeholder="Nombre del Adicional" class="form-control input-placedark input-dark" v-model="key">
                                </b-col>
                                <b-col cols="12" sm="12"	md="12"	lg="4"	xl="5">
                                    <input type="text" placeholder="Valor del Adicional" class="form-control input-placedark input-dark" v-model="value">
                                </b-col>
                                <b-col cols="12" sm="2" md="2" lg="12"	xl="2">
                                    <button v-if="validateFieldsAdicionales()" class="btn btn-primary" @click="addAdicional"><i class="fa fa-plus"></i> Agregar</button>
                                    <button v-else class="btn btn-secondary" disabled><i class="fa fa-plus"></i> Agregar</button>
                                </b-col>
                            </b-row><br>
                            <b-row>
                                <b-table striped hover :items="items_adicionales" :fields="fields_adicionales">
                                    <template striped hover slot="acciones" slot-scope="row">
                                        <b-button-group>
                                            <b-button variant="danger" title="Eliminar Adicional" @click="deleteAdicional(row.index)"><i class="fa fa-trash"></i></b-button>
                                        </b-button-group>
                                    </template>
                                </b-table>
                            </b-row>
                        </b-card>
                    </b-collapse>
                </div>
            </b-col>            
        <b-col cols="12" sm="12"	md="6"	lg="5"	xl="4">
            <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6" class="text-left">
                <b-button v-b-modal.otroscargosmodal1 variant="secondary" :disabled="this.items.length > 0 ? false:true"><i class="fa fa-hand-holding-usd"></i> Otros Cargos</b-button>
                    <b-modal id="otroscargosmodal1" title="Agregar Otros Cargos" size="lg" centered v-model="otroscargosmodal" >
                    <template>
                        <b-row>
                        <b-col cols="12" sm="12"	md="6"	lg="6"	xl="6">
                            <select class="form-control input-placedark input-dark" v-model="otroCargo">
                            <option v-for="otrocargo in listaOtrosCargos" :value="otrocargo" :key="otrocargo.codigo">{{ otrocargo.descripcion }}</option>
                            </select>
                        </b-col>
                        <b-col cols="2" sm="2"	md="1"	lg="1"	xl="1"><p class="mt-2">{{ moneda.simbolo }}</p></b-col>
                        <b-col cols="8" sm="8"	md="4"	lg="4"	xl="4">
                            <b-form-input
                            type="number"
                            v-model="montoOtroCargo"
                            placeholder="Monto del cargo"
                            @keyup.enter="addMontoCargo()"
                            ></b-form-input>
                        </b-col>
                        <b-col cols="2" sm="2"	md="1"	lg="1"	xl="1">
                            <b-button variant="success" @click="addMontoCargo()"><i class="fa fa-plus"></i></b-button>
                        </b-col>
                        </b-row>
                        <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                            <b-table  
                                striped 
                                hover 
                                small 
                                responsive
                                outlined
                                :fields="otroscargos_fields" 
                                :items="listaOtrosCargosAgregados" 
                                :busy="otroscargosbusy">
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong> Cargando...</strong>
                                </div>
                                <template slot="descripcion" slot-scope="row">
                                    <div v-if="row.item.codigoCargoDescuento==50">
                                        Cargos globales que no afectan la base imponible del IGV/IVAP
                                    </div>
                                </template>
                                <template slot="montoCargo" slot-scope="row">
                                    {{ moneda.simbolo }} {{ row.item.montoCargoDescuento }}
                                </template>
                                <template slot="acciones" slot-scope="row">
                                    <b-button size="sm" variant="danger" @click="deleteOtroCargo(row.index, row.item)"><i class="fa fa-trash"></i></b-button>
                                </template>
                            </b-table>
                        </b-col>
                        </b-row>
                    </template>
                    <div slot="modal-footer" class="w-100">
                        <b-row>
                        <b-col cols="12" sm="12"	md="8"	lg="8"	xl="8">
                            <b-button size="sm" variant="danger" @click="cerrarmodalOtroCargo()"><i class="fa fa-times"></i> Cerrar</b-button>
                        </b-col>
                        <b-col cols="12" sm="12"	md="4"	lg="4"	xl="4">
                            Sumatoria de cargos: {{ moneda.simbolo }} {{ accumulateOtrosCargos() }}
                        </b-col>
                        </b-row>
                    </div>
                </b-modal>
                </b-col>
                <!--DECUENTO GLOBAL-->
            <b-col cols="12" sm="12" md="12" lg="12" xl="6">
                        <b-button
                            v-b-modal.descuentosglobalI
                            variant="secondary"
                            :disabled="this.items.length > 0 ? false:true">
                            <i class="fas fa-tags"></i> Dscto Global
                        </b-button>
                <b-modal 
                              id="descuentosglobalI"
                              title="Agregar Descuento Global"
                              size="lg"
                              centered
                              v-model="descuentoglobalM">
                        
      
       <template>
                <b-row class="azaz">
                    <b-col cols="12" sm="3" md="3" lg="3" xl="3" class="mt-4">
                        <select disabled class="custom-select mr-sm-2 input-placedark input-dark"  v-model="especificacionIgv">
                          <option
                            :value="afec.id"
                            v-for="afec in listaafectacion"
                            v-bind:key="afec.id"
                          >{{ afec.descripcion }}
                          </option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="1" md="1" lg="1" xl="1" class="botondescuento mt-4">
                        <!-- <b-form-checkbox class="mt-4" v-model="descuentoglobalC">Dscto</b-form-checkbox> -->
                          Dscto
                    </b-col>
                    <b-col cols="12" sm="3" md="3" lg="3" xl="3" class="mt-4" v-if="!descuentoglobalC">
                        <b-input-group size="xs" prepend="S/."> 
                            <input :disabled='gravado'  v-model="descuentoItemMontoG"
                                    class="form-control input-requerido input-dark" />
                        </b-input-group>
                    </b-col>
                    <b-col cols="12" sm="3" md="3" lg="3" xl="3" class="mt-4" v-else >                      
                        <b-input-group size="xs" append="%">
                            <input v-model="descuentoItemPorcentajeG"
                                    class="form-control input-requerido input-dark"/>
                        </b-input-group>
                    </b-col>
                    <b-col v-if="!descuentoglobalC">
                      <p>Descuento con IGV</p>
                      <div>
                          <!-- <div>{{ moneda.simbolo }} {{descuentoItemMontoG}}</div> -->
                           <div v-for="(i, ind) in listarMontos" :key="ind" >
                              <b-row>
                                <b-col xl="" class="">
                                  <b>{{ moneda.simbolo }} {{i.monto}}</b>
                                </b-col>
                                <b-col xl="">
                                  <i @click="borrarDescuento(ind)" class=" fa fa-1x fa-times-circle text-danger cursor"></i>
                                </b-col>
                              </b-row>
                           </div>
                      </div>
                    </b-col>
                    <b-col v-else>
                      <p>Descuento con IGV</p>
                      <div>
                          <div>{{ moneda.simbolo }} {{descuentoItemPorcentajeG}}</div>
                      </div>
                    </b-col> 
                    <b-col>
                      <p>Venta Total</p>
                         <div>{{ moneda.simbolo }} {{ accumulateTotalSale()}}</div>
                    </b-col>              
                </b-row>
          </template>
          <div slot="modal-footer" class="w-100">
            <b-row>
                <b-col cols="10" >
                    <b-button @click="addDescuentosGlobales()" variant="success">
                        Guardar
                        <i class="far fa-save"></i>
                    </b-button>
                </b-col>
                <b-col cols="2" >
                      <b-button size="sm" variant="danger" @click="cerrarmodaldsctGlobal()">
                        <i class="fa fa-times"></i> Cerrar
                      </b-button>
                </b-col>
            </b-row>
          </div>
                </b-modal>
            </b-col>
            <!--FIN DESCUENTO GLOBAL-->
            </b-row>
            <b-modal v-model="modalSustentaGastos" title="Ventana Informativa">
                Para este tipo de boleta tenga en cuenta: <br>
                <b>1.</b> El tipo de documento debe ser <b>DNI</b> ó <b>RUC 10</b><br>
                <b>2.</b> Debe llevar Código Sunat <b>84121901</b> ó <b>80131501</b><br><br>
                Puede consultar los códigos Sunat en: <b-link href="http://cps.facturaonline.pe/" target="_blank" variant="primary">cps.facturaonline.pe</b-link>
                <div slot="modal-footer">
                    <b-button variant="primary" @click="cerrarModalSustentosGastos()">OK</b-button>
                </div>
            </b-modal>       
            <b-row>
                <b-col>
                    <div class="text-center">
                        <strong>TOTALES</strong>
                    </div>
                </b-col>
            </b-row><hr>
            <b-row>
                <b-col cols="12" sm="6"	md="6"	lg="6"	xl="6">
                    <div><strong>IGV:</strong></div>
                    <div><strong>Venta Gravada:</strong></div>
                    <div><strong>Venta Exonerada:</strong></div>
                    <div><strong>Venta Inafecta:</strong></div>
                    <div><strong>Venta Gratuita:</strong></div>
                    <div><strong>ICBPER:</strong></div>
                    <div><strong>Descuento Anticipos:</strong></div>
                    <div><strong>Descuentos:</strong></div>
                    <div><strong>Descuento Global:</strong></div>
                    <div><strong>Cargos:</strong></div>
                    <div><strong>Venta:</strong></div>
                    <b-row>
                        <b-col cols="12">
                            <template v-if="tipoOperacion == '1001'">
                                <hr>
                                <select class="form-control input-placedark input-dark" v-model="detraccion">
                                    <option v-for="detraccion in listaDeDetracciones" :value="detraccion" :key="detraccion.codigo">{{ detraccion.descripcion }}</option>
                                </select>
                                <br>
                                <em>Cuenta de Detracciones</em>
                            </template>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="3" sm="6"	md="4"	lg="3"	xl="2">
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                    <div>
                        {{ moneda.simbolo }}
                    </div> 
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                    <div>
                        {{ moneda.simbolo }}
                    </div>
                </b-col>
                <b-col cols="9" sm="4"	md="4"	lg="4"	xl="4">
                    <div class="alineacionTotales">
                        {{ accumulateIgv() }}
                    </div>
                    <!-- <div v-if="descuentoGlobalMonto != '' || descuentoGlobalPorcentaje != ''" class="alineacionTotales">
                        {{ totalVentaGravada }}
                    </div> -->
                    <div class="alineacionTotales">
                        {{ accumulateRecordedSale() }}
                    </div>
                    <div class="alineacionTotales">
                        {{ accumulateExoneratedSale() }}
                    </div>
                        <div class="alineacionTotales">
                        {{ accumulateUnaffectedSale() }}
                    </div>
                    <div class="alineacionTotales">
                        {{ accumulateFreeSale() }}
                    </div>
                    <!-- <div class="alineacionTotales">
                        {{ accumulateExportSale() }}
                    </div> -->
                    <div class="alineacionTotales">
                        {{accumulateICBPER().toFixed(2)}}
                    </div>
                    <div class="alineacionTotales">
                        {{accumulateAnticipos()}}
                    </div>
                    <div class="alineacionTotales"> 
                        {{ accumulateDescuento() }}
                    </div>
                    <div class="alineacionTotales">
                    {{ accumulatedescuentoG() }}
                    </div>
                    <div class="alineacionTotales">
                        {{ accumulateOtrosCargos() }}
                    </div>
                    <div class="alineacionTotales">
                        {{ accumulateTotalSale() }}
                    </div>
                    <template v-if="tipoOperacion == '1001'">
                        <hr>
                        <b-row>
                            <b-col cols="5">Dscto (%)</b-col>
                            <b-col cols="3">:</b-col>
                            <b-col cols="4">{{ detraccion.porcentajeDetraccion }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="5">Monto Dscto</b-col>
                            <b-col cols="3">:</b-col>
                            <b-col cols="4">{{ moneda.simbolo }} {{ montoDetraccionCalc() }}</b-col>
                        </b-row>
                        <b-row>
                            <template v-if="cuentaDetracionAdmin != ''">
                                <b-col cols="12">
                                    <b-input disabled :value="cuentaDetracionAdmin"></b-input>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-label>Cargando <i class="fa fa-spin fa-spinner"></i></b-label>
                            </template>
                        </b-row>
                    </template>
                </b-col>
            </b-row>
            <br>
            <div class="row">
                <div class="col-md-6">
                    <template v-if="validateTicket()">
                        <b-button v-if="!cargandoemision" variant="success" @click.prevent="limpiarExcel">Emitir Directo <i class="fa fa-location-arrow"></i></b-button>
                        <b-button v-else variant="success" disabled >Emitiendo... <i class="fa fa-spin fa-spinner"></i></b-button>
                    </template>
                    <template v-else>
                        <b-button class="btn btn-secondary" variant="success" disabled>Emitir Directo <i class="fa fa-location-arrow"></i></b-button>
                    </template>
                    </div>
                <div class="col-md-4">
                    <button class="btn btn-primary" @click.prevent="sendPreviw(true)"><i class="fa fa-search"></i> Previsualizar</button>
                </div>
            </div>                
            </b-col>
            <vue-snotify></vue-snotify> 
            <template v-if="postEmision">
                <vista-post-emison :idDocumentPreview="idDocumentPreview" :tipoDocPreview="tipoDocPreview"></vista-post-emison>
                <!-- TEMPORAL************** -->
                <!-- <b-modal size="xs" v-model="modalimpresion">
                    <template slot="modal-header">
                        <div class="text-center">
                        Telemovil.global
                        </div>
                    </template>
                    <template>
                    <plantilla :impresion="dataImpresion" :printweb="printweb"></plantilla>
                    </template>
                    <template slot="modal-footer">
                        <b-row>
                            <b-col cols="4" class="pr-0" >
                                <template>
                                    <b-form-input style="border-color:black;color:black" type="number" placeholder="Num. Celular" v-model="numeroWhatsApp"  @keyup.enter="send_message()"></b-form-input>
                                </template>
                            </b-col>
                            <b-col cols="2" class="pl-0">
                                <template>
                                    <b-button title="Enviar a Whatsapp" style="border-color:black" variant="success"  @click="send_message()">
                                        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>
                                    </b-button>
                                </template>
                            </b-col>
                            <b-col cols="3" class="">
                                <b-button size="sm"  class="btn btn-info" @click="print()"><i class="fas fa-print"></i> Imprimir</b-button>
                            </b-col>
                            <b-col cols="3" class="">
                                <b-button size="sm" class="btn btn-success" @click="nuevaImpresion()"><i class="fas fa-plus"></i> Nuevo</b-button>
                            </b-col>
                        </b-row>
                    </template>
                </b-modal> -->
        <!-- TEMPORAL************** -->
           </template> 
        </b-row>
    </b-card>
    <b-card v-else>
        <b-alert show variant="primary" class="centerpreview">
            <strong>
            <i class="fa fa-2x fa-exclamation-circle"></i> 
              Vista Previa - Datos aún sin valor oficial
            </strong>
          </b-alert>
        <b-row>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="5">
              <em><strong>Para:</strong></em><br>
              <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                  RUC:
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="9">
                  {{ receptor.numero }}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                  Razon Social:
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="9">
                    {{ receptor.razonSocial }}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                  Direccion:
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="9">
                  {{ receptor.direccion }}
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="7">
              <em><strong>Detalles:</strong></em><br>
              <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                  Moneda:
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="8">
                  {{ moneda.descripcion }}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                  Condicion de Pago:
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="8">
                    {{ formadepago.nombre }}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                  Fecha Emision:
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="8">
                  {{ femision }}
                </b-col>
              </b-row>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="12">
              <b-table responsive
                :small="small"
                :items="items"
                :fields="items_fields"
                :outlined="outlined"
                >
                <template slot="index" slot-scope="row">
                    <template v-if="row.item.idProducto !='-' && row.item.idProducto !=''">
                        <i title="contiene idProducto" style="color:lightgreen" class="fas fa-check"></i>
                    </template> 
                    {{ row.index +1 }}                
                </template>
                <template slot="precioUni" slot-scope="row">
                    <template v-if="row.item.adicional && row.item.adicional.precioVentaUni" >
                        {{row.item.adicional.precioVentaUni}}
                    </template>
                    <template v-else-if="row.item.precioVentaUnitario">
                        {{row.item.precioVentaUnitario}}
                    </template>
                </template>
                <template slot="descuentoUni" slot-scope="row">
                    <template v-if="row.item.adicional.indicardorDsct == '01'">
                        S/ {{row.item.adicional.dsctSoles}}
                    </template>
                    <template v-else-if="row.item.adicional.indicardorDsct == '02'">
                        {{row.item.adicional.dsctPorcentaje}}%
                    </template>
                    <template v-else>
                        {{0.00}}
                    </template>
                </template>
                <template slot="valorVentaVista" slot-scope="row">
                    <template v-if="row.item.valorVentaVista">
                        {{row.item.valorVentaVista}}
                    </template>
                    <template v-else-if="row.item.valorVenta">
                        {{row.item.valorVenta}}
                    </template>
                </template>
                <template slot="precioT" slot-scope="row">
                    <!-- vista previa -->
                   <!-- <div v-if="row.item.adicional.precioTotalIGV !=''">
                        {{(row.item.adicional.precioTotalIGV)}}
                    </div>
                    <div v-else-if="row.item.adicional.precioTotalIGV === '' || row.item.adicional.precioTotalIGV == 0">
                        {{(parseFloat(row.item.cantidad) * row.item.adicional.precioVentaUni).toFixed(2) }}
                    </div> -->
                    {{(parseFloat(row.item.cantidad) * row.item.adicional.precioVentaUni).toFixed(2)}}
                </template>
              </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" sm="12"	md="6"	lg="7"	xl="8">
              <em><strong>Informacion Adicional</strong></em><br><br>
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                  <b-alert show variant="success">
                    <b-row>
                      <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <strong>Extras:</strong>
                      </b-col>
                      <b-col v-if="fvencimiento != ''" cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        Fecha de Vencimiento: {{ fvencimiento | moment('DD/MM/YYYY hh:mm:ss A') }}<br>
                      </b-col>
                    </b-row>
                  </b-alert>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                  <b-alert show variant="success">
                    <b-row>
                      <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                        <strong>Guias Relacionadas:</strong>
                      </b-col>
                      <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                        <ul>
                            <li v-for="item in items_guias" :key="item.serie">
                            {{ item.serie }} - {{ item.numero }}
                            </li>
                        </ul>
                      </b-col>
                    </b-row>
                  </b-alert>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                  <b-alert show variant="success">
                      <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                          <strong>Datos Adicionales:</strong>
                        </b-col>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                            <ul>
                                <li v-for="item in items_adicionales" :key="item.serie">
                                {{ item.key }} - {{ item.value }}
                                </li>
                            </ul>
                        </b-col>
                      </b-row>
                  </b-alert>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="12"	md="6"	lg="5"	xl="4">
              <b-row>
                <b-col>
                  <div class="text-center">
                    <strong>TOTALES</strong>
                  </div>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                  <div><strong>IGV:</strong></div>
                  <div><strong>Venta Gravada:</strong></div>
                  <div><strong>Venta Exonerada:</strong></div>
                  <div><strong>Venta Inafecta:</strong></div>
                  <div><strong>Venta Gratuita:</strong></div>
                  <div><strong>Venta Exportación:</strong></div>
                  <div><strong>ICBPER:</strong></div>
                  <div><strong>Descuento Anticipos:</strong></div>
                  <div><strong>Descuentos:</strong></div>
                  <div><strong>Descuento Global:</strong></div>
                  <div><strong>Cargos:</strong></div>
                  <div><strong>Venta:</strong></div>
                  <b-row>
                    <b-col cols="12">
                      <template v-if="tipoOperacion == '1001'">
                        <hr>
                        <select class="form-control input-placedark input-dark" v-model="detraccion">
                          <option v-for="detraccion in listaDeDetracciones" :value="detraccion" :key="detraccion.codigo">{{ detraccion.descripcion }}</option>
                        </select>
                        <br>
                      </template>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div> 
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                </b-col>
                <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                  <div class="alineacionTotales">
                    {{ accumulateIgv() }}
                  </div>
                  <div v-if="descuentoGlobalMonto != '' || descuentoGlobalPorcentaje != ''" class="alineacionTotales">
                    {{ totalVentaGravada }}
                  </div>
                  <div v-else class="alineacionTotales">
                    {{ accumulateRecordedSale() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateExoneratedSale() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateUnaffectedSale() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateFreeSale() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateExportSale() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateICBPER().toFixed(2)}}
                  </div>
                  <div class="alineacionTotales">
                      {{accumulateAnticipos()}}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateDescuento() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulatedescuentoG() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateOtrosCargos() }}
                  </div>
                  <div class="alineacionTotales">
                    {{ accumulateTotalSale() }}
                  </div>
                  <template v-if="tipoOperacion == '1001'">
                    <hr>
                    <b-row>
                      <b-col cols="4">{{ detraccion.porcentajeDetraccion }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="8">{{ moneda.simbolo }} {{ montoDetraccionCalc() }}</b-col>
                    </b-row>
                  </template>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <template v-if="tipoOperacion == '1001'">
                    <b-alert show variant="info">
                      <b-row>
                        <b-col cols="6">Cuenta de Detracciones: </b-col>
                        <b-col cols="6">
                          <template v-if="cuentaDetracionAdmin != ''">
                            <b-col cols="12">
                              <template v-if="cuentaDetracionAdmin != ''">
                                {{ cuentaDetracionAdmin }}
                              </template>
                              <template v-else>
                                No existe cuenta de detracción, registrelo en Administrador/Perfil
                              </template>
                            </b-col>
                          </template>
                          <template v-else>
                            Cargando <i class="fa fa-spin fa-spinner"></i>
                          </template>
                        </b-col>
                      </b-row>
                    </b-alert>
                  </template>
                </b-col>
              </b-row>
              <br>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4" sm="6"	md="8"	lg="8"	xl="8"></b-col>
            <b-col cols="4" sm="3"	md="2"	lg="2"	xl="2">
                <template v-if="validateTicket()">
                <button v-if="!cargandoemision" class="btn btn-primary botonesemitirBoleta" @click.prevent="validarImporteTotal"><i class="fa fa-location-arrow"></i> Emitir</button>
                <button v-else class="btn btn-seconday botonesemitirBoleta"><i class="fa fa-spin fa-spinner"></i> Emitiendo...</button>
                </template>
                <template v-else>
                <button class="btn btn-secondary botonesemitirBoleta" disabled><i class="fa fa-send"></i> Emitir</button>
                </template>
            </b-col>
            <b-col cols="4" sm="3"	md="2"	lg="2"	xl="2">
                <template>
                <button class="btn btn-danger botonesemitirBoleta" @click="sendPreviw(false)"><i class="fa fa-arrow-circle-left"></i> Atras</button>
                </template>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import vSelect  from 'vue-select'
import axios from 'axios'
import { UnidadMedida } from '@/shared/utils'
import { ListaOperacionB } from '@/shared/utils'
import { TipoAfectacion } from '@/shared/utils'
import { EspecificacionIgvTipo1 } from '@/shared/utils'
import { EspecificacionIgvTipo2 } from '@/shared/utils'
import { EspecificacionIgvTipo3 } from '@/shared/utils'
import { TipoMoneda } from '@/shared/utils'
import { FormaPago } from '@/shared/utils'
import { FormaPagoCuentasCobrar } from '@/shared/utils'
import { TipoGuia } from '@/shared/utils'
import { DocumentosIdentidad } from '@/shared/utils'
import vistaPostEmision from '@/components/comunes/VistaPostEmision'
import {tasaicbper} from '@/services/funciones'
import Import from '@/components/comunes/pImportItems'
import { XlsxRead, XlsxJson, XlsxTable } from "vue-xlsx/dist/vue-xlsx.es.js"
// import ImportItems from '@/components/comunes/ItemsImport'
import MasivaGuia from '@/components/comunes/MasivaGuia'
import Plantilla from '@/components/comunes/PlantillaImpresionTemporal'
import { Departamentos } from '@/shared/utils'
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
 
export default {
    name: 'BoletaEmision',
    components: {
        Datepicker,
        vSelect,
        'vista-post-emison': vistaPostEmision,
        XlsxRead,
        XlsxJson,
        XlsxTable,
        Import,
        // ImportItems,
        MasivaGuia,
        Plantilla,
        PulseLoader
    },
    data: () => {
        return {
            storageItem:[],
            itemsAlmacenados:'',
            //temporal
            dataImpresion: {},
            printweb: false,
            modalimpresion: false,
            numeroWhatsApp:'',      
            //temporal
            timer: null,
            nuevaBusqueda:false,
            nuevaBusquedaAlmacenada:[],
            montoValorUnitario2:'',
            montoIgvGlobal:'',
            inafecto:'',
            icbper: false,
            sumatoriaOtrosCargos: 0,
            guardandootroscargos: true,
            otroscargosmodal: false,
            otroCargo: {codigo: '50', descripcion: 'Cargos globales que no afectan la base imponible del IGV/IVAP'},
            listaOtrosCargos: [
                {codigo: '50', descripcion: 'Cargos globales que no afectan la base imponible del IGV/IVAP'}
            ],
            listaOtrosCargosAgregados: [],
            otroscargos_fields: [
                {key: 'descripcion', label: 'Descripcion', sortable: true},
                {key: 'montoCargo', label: 'Monto', sortable: true},
                // {key: 'montoBaseCargo', label: 'Base', sortable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            otroscargosbusy: false,
            montoOtroCargo: '',
            v1:'',
            tiporeceivers: false,
            publicogeneral: '',
            direcciones: [],
            listaCorreos: [],
            verDirecciones: false,
            sinresultados: false,
            tipoDocPreview: 0,
            postEmision: false,
            idDocumentPreview: 0,
            ticketPrev: {
                data: '',
                bandera: false
            },
            descuentoGlobalPorcentaje: '',
            descuentoGlobalMonto: '',
            outlined: true,
            previwEmit: true,
            contingencia: false,
            show: true,
            small: true,
            otrosCargos: 0,
            totalDescuentosAcumulados: '',
            descuentoItemMonto: '',
            descuentoItemPorcentaje: '',
            tipodoc: '2',
            indexSerie: 0,
            seriesCargadas: true,
            newSerie: true,
            rolSeries: '',
            listaSeries: [],
            // listaSeriesLocal:[],
            setIndex: -1,
            setUpdateItem: false,
            listades: true,
            nodescription: false,
            cargandoDescription: false,
            listaDescription: [],
            listaReceptoresProductCode: [],
            listaReceptoresCodeBarrasSunat: [],
            cargandoCodBarras: false,
            cargandoBarrasSunat: false,
            vbarras: false,
            listarecProduct: true,
            listarecProductBarrasSunat: true,
            norecProduct: false,
            norecProductBarrasSunat: false,
            listarecProductCode: false,
            placeholdercodigo: 'C. Sunat (*)',
            idProducto: '-',
            codigoProducto: '',
            codigoSunatBarras: '',
            habilitado: true,
            unidades: UnidadMedida,
            listadeoperaciones: ListaOperacionB,
            listaafectacion: TipoAfectacion,
            EspecificacionIgv: EspecificacionIgvTipo1, 
            EspecificacionIgv2: EspecificacionIgvTipo2, 
            EspecificacionIgv3: EspecificacionIgvTipo3, 
            tipoMoneda: TipoMoneda,
            formaPago: FormaPago,
            formaPago1: FormaPago,
            formaPago2: FormaPagoCuentasCobrar,
            tiposGuia: TipoGuia, 
            documentosIdentidad: DocumentosIdentidad,
            ticket: {
                monedero:"",
                nombreMonedero:"",
                sumatoriaIsc:0.0,
                totalValorVenta :0.0,
                tipoOperacion: '',
                serie: '',
                montoTotalImpuestos: 0.00,
                totalVentaGravada: 0.00,
                cargosDescuentosGlobales:[],
                sumatoriaIgv: 0.00,
                importeTotal: 0.00,
                sumatoriaIcbper: 0.00,
                guiasRelacionada: [],
                adicional: {
                    totalDescuentoItem: '',
                    dirAlternativa: '',
                    anticipos:{},
                    totalAnticipos:0.0,   
                    tipo_igv: '',      
                },
                items: [],
                receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccion: ''
                }
            },
            montoTotalImpuestos: 0.00,
            totalVentaInafecta: 0.00,
            totalVentaExonerada: 0.00,
            totalVentaExportacion: 0.00,
            totalVentaGravada: 0.00,
            sumatoriaIgv: 0.00,
            importeTotal: 0.00,
            baseCargo: 0.00,
            sumatoriaIgvGratuitas: 0.00,
            receptor: {
                tipo:'',
                numero:'',
                razonSocial:'',
                direccion:'',                 
            },
            adicional: {
                dirAlternativa: ''
            },
            guiasRelacionada: [],
            cargandoreceptor: false,
            listarec: true,
            especificacion:{
                codigo: '10',
                descripcion: 'Operacion onerosa',
                codigoTributo: '1000'
            },
            moneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            },
            items_adicionales: [],
            fields_adicionales: [
                {key: 'key', label: 'Clave', sorteable: true},
                {key: 'value', label: 'Valor', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true},   
            ],       
            tickets: [],
            tickets_fields: [
                {key: 'serie', label: 'Serie', sorteable: true},
                {key: 'numero', label: 'Numero', sorteable: true},
                {key: 'emision', label: 'Emisión', sorteable: true},
                {key: 'receptor', label: 'Receptor', sorteable: true},
                {key: 'moneda', label: 'Total', sorteable: true},
                {key: 'estado', label: 'Estado', sorteable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            items_guias: [],
            fields_guias: [ 
                {key: 'serie', label: 'Serie', sorteable: true},
                {key: 'numero', label: 'Numero', sorteable: true},
                {key: 'tipoGuia2', label: 'Tipo', sorteable: true},
                {key: 'acciones', label: 'Acciones', sorteable: true}    
            ],
            itemGuia: {
                numero: '',
                tipo: ''
            },
            itemAdicional: {
                key: '',
                value: ''
            },
            options: [
                { value: 1, text: 'Boleta Comercial' },
                { value: 2, text: 'Boleta Contingencia' }
            ],
            typeTicket: 1,
            largeModal: false,
            receptor: {},
            listaReceptores: [],
            tipoOperacion: '0101',
            typeTicket: 1,
            unidadMedidaCantidad: 'NIU',
            precioVentaUnitario: '',
            vunitario: false,
            especificacionIgv: '01',
            Especificacion: [],
            formadepago: {
                codigo: '008',
                nombre: 'Efectivo ventas menores'
            },
            ordenCompra: '',
            seriedeguia: '',
            numerodeguia: '',
            tipodeguia: '09',   
            info: null,
            checkserie: false,
            responsecheckserie: '',
            checkseriecon: false,
            responsecheckseriecon: '',
            items: [],    
            items_fields: [
                {key: "tieneID",label:''},
                {key: 'index', label: 'N°'},
                {key: 'cantidad', label: 'Cant.', sorteable: true},
                {key: 'descripcion', label: 'Descripción', sorteable: true},
                // {key: 'valorUnitarioVista', label: 'Valor Unitario', sorteable: true},
                {key: "stock", label: "Stock", sortable: true },
                {key: "precioUni", label: "P. Unit", sortable: true },
                // {key: 'descuento', label: 'Descuento', sorteable: true},
                {key: "descuentoUni", label: "Desct.", sortable: true },
                {key: 'valorVentaVista', label: 'Valor Total', sorteable: true},
                {key: 'montoAfectacionIgv', label: 'Igv', sorteable: true},
                {key: "precioT",label:"P. Total"},
                {key: 'acciones', label: 'Acciones', sorteable: true},
            ],
            stock:'',
            valor: '',
            serie: '',
            seriecon: '',
            es: es,
            femision: '',
            fvencimiento: '',
            key: '',
            value: '',
            itemTitleSubtotal: 'Valor Unitario',
            descuento: false,
            itemTitleTotal: 'Valor Total',
            ventaGratuita: false,
            checkvalorunitario: false,
            cantidad: 1,
            descripcion: '',
            precioVentaUnitario: '',
            valorUnitario: '',
            servicio: false,
            checkdescripcion: false,
            responsecheckdescripcion: '',
            codigoProducto: '',
            checkcodigo: false,
            responsecheckcodigo: '',
            checkcantidad: false,
            responsecheckcantidad: '',
            checkprecioventaunitario: false,
            numero: '',
            tipoDocumento: 0,
            cargandoemision: false,
            currentdate: '',
            validadorseries: 0,
            diasnopermitidos: {
            ranges: [],

            },
            bufferProforma: {},
            bufferOrdenpago: {}, 
            file: null,
            arraydeprueba:[],
            arraydeprueba2:{},
            coleccion:[],
            itemsEX:[],  
            itemsEXz:[],
            item:[],
            action: {
                i: false,
                reset: false,
                b:false
            },
            borraritem:true,
            doc:null,

            switchAnticipo: false,
            disabledAnticipo: false,
            anticipo:false,
            buttonRegularizacionAnticipos: true,
            modalAnticipos: false,
            cargandoAnticipos: false,
            docAnticipos: [],
            docAnticipos_fields: [
                { key: "serie", label: "Serie", sorteable: true },
                { key: "numero", label: "Numero", sorteable: true },
                { key: "idReceptor", label: "RUC", sorteable: true },
                { key: "razonSocial", label: "Razon Social", sorteable: true },
                { key: "tipoAfectacion", label: "Afectacion", sorteable: true },
                {
                    key: "montoRegularizar",
                    label: "Saldo por Regularizar",
                    sorteable: true
                },
                { key: "monto", label: "Monto a Aplicar", sorteable: true },
                { key: "agregar", label: "Agregar", sorteable: true }
            ],
            striped: true,
            outlined: true,
            selectedAnticipos: [],
            totalAnticipos: 0.0,
            totalAnticiposValor: 0.0,
            totalAnticiposIgv: 0.0,
            valGrabadaAnticipos:'',

            currentPage: 1,
            limite: 10,
            orden: "desc",
            total: 0,
            desde: "",
            hasta: "",
            totalVentaExonerada2:0.0,
            totalVentaInafecta2:0.0,
            descuentoglobalM:false,
            descuentoglobalC:false,
            listarMontos:[],
            descuentoItemMontoG:'',
            descuentoItemPorcentajeG:'',
            valorGlobal:'',
            cargosDescuentosGlobales:[],
            gravado: false,
            idOrdenPago:'',
            searchItems:false,
            ListProductos:[],
            List_Productos:[
                 { key: "codigo", label:"codigo", sortable:true},
                { key: "descripcion", label:"Producto", sortable:true},
                { key: "precioUnitario", label:"P.Venta", sortable:true},
                { key: "precioCosto", label:"P.Costo", sortable:true},
                { key: "stock", label:"Stock", sortable:true},
                { key: "cantidad", label:"Cantidad", sortable:true},
                { key: "accion", label:""}
            ],
            item: {},
            action: {
                i: false,
                reset: false,
                b:false,
                z:false
            },
            accion:{
                i:false,
                reset:false
            },
            mostrarListaProduc:false,
            subirItems:false,
            itemsModal:[],
            mostrardni:false,
            listadni:[],
            guiasdoc:null,
            guiasmasiva:[],
            pasandoGuias:[],
            errorboleta:false,
            error1:'',
            error2:'',
            error3:'',
            codigoProductoGs1:'',
            isc:false,
            montoISC:'',
            selectedISC: 0,
            optionsISC: [
                { value: 0, text: 'Opciones ISC' },
                { value: 1, text: 'Valor Venta %' },
                { value: 2, text: 'Monto Específico' },
                { value: 3, text: 'Precio Sugerido' },
            ],
            porcentajeISC:'',
            valorUniSinIsC:'',
            cuadroISC:false,
            flechaISC:false,
            iscCodigo:'',
            bufferBoleta:{},
            modalSustentaGastos:false,
            unoDieciocho:1.18,
            ceroDieciocho:0.18,
            dieciocho:18,
            // unoUno:1.1,
            // ceroUno:0.1,
            // diez:10,
            unoUno:1.105,
            ceroUno:0.105,
            diez:10.5,
            igvGlobal:null,
            monederoPago:'',
            colorPago1:false,
            colorPago2:false,
            colorPago3:false,
            colorPago4:false,
            colorPago5:false,
            colorPago6:false,
            colorPago7:false,
            colorPago8:false,
            codDescripcion:'',
            opcionesOrdenadas: [], // Inicialmente vacío
            reciveArrayActualizado:[],
            cargandoInformacion:false,
            saveAnticipos:[],
            valorAnticipo:'',
            cotributo:0.00,
            itemEditado:false,
            aula:'',
            gradoYseccion:'',
            dniAlumno:'',
            nomApeAlumno:'',
            ubigeoOrigenDom:'',
            prependUbigeoOrigen: '',
            prependUbigeoDestino: '',
            direccionDomAlumno:'',
            direccionColegio:'',
            modalUbigeoOrigen:false,
            departamentoSeleccionadoUbigeoOrigen: '00',
            provinciaSeleccionadaUbigeoOrigen: '',
            distritoSeleccionadoUbigeoOrigen: '',
            listDepartamento: Departamentos,
            listProvinceOrigen: [],
            listDistrictOrigen: [],
            distOrigen: false,
            distOrigenCargando:  false,
            provOrigen: false,
            provOrigenCargando: false,
            departamentoSeleccionadoUbigeoDestino: '00',
            provDestino: false,
            provDestinoCargando: false,
            provinciaSeleccionadaUbigeoDestino: '',
            listProvinceDestino: [],
            listDistrictDestino: [],
            distDestino: false,
            distDestinoCargando: false,
            distritoSeleccionadoUbigeoDestino: '',
            ubigeoDestinoDom:'',
            periodoAcademido:'',
        }
    },
    mounted () {
        this.getSeries(),
        this.initIgv(),
        this.initDates(),
        // this.serieLocal(),
        this.quickEmisionProforma()
    },
    computed: {
        state () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serie.length == 0){

            } else if (!expreg.test(this.serie)) {
                return false
            } else if(this.serie.length == 3 ){
                return true
            }
        },
        invalidFeedback () {
            let expreg = new RegExp("^[A-Z0-9]{3}$")
            if (this.serie.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 3 caracteres'
            }
        },
        validFeedback () {
        return this.state === true ? 'Perfecto': ''
        },
        stateSerieGuia () {
            let expreg = new RegExp("^[A-Z0-9]{4}$")
            let numeros = new RegExp("^[0-9]$")
            let arrayserie = this.seriedeguia.split('')
            if(arrayserie[0] == 'T' || arrayserie[0] == 'V' || numeros.test(arrayserie[0])){
                if (this.seriedeguia.length == 0){

                } else if (!expreg.test(this.seriedeguia)) {
                    return false
                } else if(this.seriedeguia.length == 4 ){
                    return true
                }
            }else{
                return false
            }  
        },
        invalidFeedbackSerieGuia () {
            if (this.seriedeguia.length == 0) {
                return 'Ingresa una Serie'
            } else {
                return 'Minimo 4 caracteres'
            }
        },
        validFeedbackSerieGuia () {
            return this.stateSerieGuia === true ? 'Perfecto' : ''
        },
        stateOrdenCompra () {
            let expreg = new RegExp("^[A-Z0-9]{1,20}$")
            if (this.ordenCompra.length == 0){

            } else if (!expreg.test(this.ordenCompra)) {
                return false
            } else if(this.ordenCompra.length < 20 ){
                return true
            }
        },
        invalidFeedbackOrdenCompra () {
            if (this.ordenCompra.length == 0) {
                return 'Ingresa una Orden de Compra'
            } else {
                return 'Caracter Invalido'
            }
        },
        validFeedbackOrdenCompra () {
            return this.stateOrdenCompra === true ? 'OC Valida' : ''
        }
    },
    watch: {
        listaReceptores: function() {
        if (
                this.listaReceptores.length == 1 &&
                this.receptor.numero.length == 8
        ) {
          this.setReceiver(this.listaReceptores[0]);
        }
      },
        'receptor.numero': function () {
            if(this.receptor.numero.length < 1){
                this.receptor.numero = '',
                this.receptor.razonSocial = '',
                this.receptor.direccion = ''
            }
            let orig = ''
            let nuev = ''
            orig=this.receptor.numero;
            nuev=orig.split(' ');
            nuev=nuev.join('');
            this.receptor.numero = nuev
            if(this.tipoDocumento == 1 ){
                this.receptor.numero = this.receptor.numero.replace(/[^0-9]/g, '');
                if(this.receptor.numero.length > 8){
                    setTimeout(() => this.receptor.numero = this.receptor.numero.slice(0,8), 200);       
                }
            }
            if(this.tipoDocumento == 6 ){
                if(this.receptor.numero.length > 11){
                    setTimeout(() => this.receptor.numero = this.receptor.numero.slice(0,11), 200);
                    
                }
            }
            
        },
        'receptor.razonSocial': function () {
            if(this.receptor.razonSocial.length < 1){
                this.receptor.numero = '',
                this.receptor.razonSocial = '',
                this.receptor.direccion = ''
            }
        },
        typeTicket: function () {
            if(this.typeTicket == 1){
                this.contingencia = false
                this.initDates();
            }else{
                this.contingencia = true
                this.initDates();
            }
        },
        vbarras: function () {
            if(this.vbarras){
                this.placeholdercodigo = 'C. Barras (*)'
            }else{
                this.placeholdercodigo = 'C. Sunat (*)'
            }
        },
        seriecon: function () {
            if(this.seriecon.length != '' && this.serie.length != 4){
                this.checkseriecon = true
                this.responsecheckseriecon = 'Requerido 4 caracteres'
            }else{
                this.checkseriecon = false
                this.responsecheckseriecon = ''
            }
        },
        cantidad: function () {
            if(this.cantidad < 0){
                this.checkcantidad = true
                this.responsecheckcantidad = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkcantidad = false
                this.responsecheckcantidad = ''
            }         
        },
        codigoProducto: function () {
            if(this.codigoProducto.length == 30){
                this.checkcodigo = true
                this.responsecheckcodigo = 'Alfanumerico de 1 a 30 caracteres '
            }else{
                this.checkcodigo = false
                this.responsecheckcodigo = ''
            }
        },
        especificacionIgv: function () {
            if(!this.ventaGratuita){
                this.especificacion.codigo = '10'
                this.especificacion.descripcion = 'Operacion onerosa'
                this.especificacion.codigoTributo = '1000'
                this.calcItem()
            }else{
                this.especificacion.codigo = '15'
                this.especificacion.descripcion = 'Grabado - Bonificaciones'
                this.especificacion.codigoTributo = '9996'
                this.calcItemGratuitos()
            }
        },
        ventaGratuita: function () {
            if(!this.ventaGratuita){
                this.especificacion.codigo = '10'
                this.especificacion.descripcion = 'Operacion onerosa'
                this.especificacion.codigoTributo = '1000'
            }else{
                this.especificacion.codigo = '15'
                this.especificacion.descripcion = 'Grabado - Bonificaciones'
                this.especificacion.codigoTributo = '9996'
            }
        },
        descripcion: function () {
            if(this.descripcion.length > 500){
                this.checkdescripcion = true
                this.responsecheckdescripcion = 'Alfanumerico de maximo 500 caracteres '
            }else if(this.descripcion.length == 0){
                this.sinresultados = false,
                this.listades = false,
                this.listaDescription = []
            }else{
                this.checkdescripcion = false
                this.responsecheckdescripcion = ''
                 this.sinresultados = false
            }
        },
        precioVentaUnitario: function () {
            if(this.precioVentaUnitario < 0){
                this.checkprecioventaunitario = true
                this.responsecheckprecioventaunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkprecioventaunitario = false
                this.responsecheckprecioventaunitario = ''
            }
            if(this.tipoOperacion == "0101EDU"){
                this.especificacionIgv = "02"
                this.valorUnitario = this.precioVentaUnitario;
            }
            if(this.especificacionIgv=='01'){
                if(!this.isc){
                     this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
                }else if(this.isc){
                    //se deja de usar el Valor Unitario
                }
               
            }
            else{
                this.valorUnitario = this.precioVentaUnitario
            }
        },
        valorUnitario: function () {
            if(this.valorUnitario < 0){
                this.checkvalorunitario = true
                this.responsecheckvalorunitario = 'Cantidad debe ser mayor a 0'
            }else{
                this.checkvalorunitario = false
                this.responsecheckvalorunitario = ''
            }
            if(this.vunitario){
                if(this.tipoOperacion == "0101EDU"){
                    this.especificacionIgv = "02"
                    this.valorUnitario = this.precioVentaUnitario;
                }
                if(this.especificacionIgv=='01'){
                    this.precioVentaUnitario = this.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
                }
                else if(this.especificacionIgv=='02') {
                    this.precioVentaUnitario = this.valorUnitario
                }
            }
        },
        servicio: function (val) {
            if(this.servicio){
                this.unidadMedidaCantidad = 'ZZ'
            }else{
                this.unidadMedidaCantidad = 'NIU'
            }
        },
        tipoDocumento: function () {
            if(this.tipoDocumento == 0){
                this.receptor.numero  ='',
                this.formaPago = this.formaPago1
            }else{
                this.formaPago = this.formaPago2
            }
            if(this.tipoDocumento == 'B'){
                this.habilitado = false
            }
            if(this.tipoDocumento == 1 && this.receptor.numero.length !=8){
                this.receptor.numero  ='',
                this.receptor.razonSocial ='',
                this.receptor.direccion =''
            }else if(this.tipoDocumento == 6 && this.receptor.numero.length !=11){
                this.receptor.numero  ='',
                this.receptor.razonSocial ='',
                this.receptor.direccion =''
            }
        },
        coleccion:function(){
            if(this.coleccion !=null){                   
                this.itemsEX = this.coleccion
                this.action.i = true        
            }
        },
        switchAnticipo: function() {
            if (this.switchAnticipo) {
                this.anticipo = true;
            } else {
                this.anticipo = false;
            }
        },
        guiasmasiva(){
          if(this.guiasmasiva !=null){
            this.items_guias = this.guiasmasiva
            this.pasandoGuias = this.guiasmasiva
            this.accion.i = true
          }else{

          }
        },
        isc(){
          if(!this.isc){
            this.montoISC = '';
            this.selectedISC = 0;
            if(!this.vunitario){
              this.valorUnitario = this.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
            }  
          }
        },
        selectedISC(){
          if(this.selectedISC == 1){
            this.iscCodigo = "01";
            this.cuadroISC = true;
          }else if(this.selectedISC == 2){
            this.iscCodigo = "02"
             this.cuadroISC = true;
          }else if(this.selectedISC == 3){
            this.iscCodigo = "03"
             this.cuadroISC = true;
          } 
        },
        tipoOperacion(){
            if(this.tipoOperacion == '0101'){
                this.especificacionIgv = "01";
            }
            if(this.tipoOperacion == '0112'){
                this.modalSustentaGastos = true;
            }
            if(this.tipoOperacion === "0101EDU"){
                this.especificacionIgv = "02"
            }
        },
        departamentoSeleccionadoUbigeoOrigen: function () {
          this.provOrigen = true,
          this.searchProvinceOrigen(1)
        },
        provinciaSeleccionadaUbigeoOrigen: function () {
          this.distOrigen = true,
          this.distOrigenCargando = true,
          this.searchDistrictOrigen(this.distOrigenCargando, 1)
        },
        distritoSeleccionadoUbigeoOrigen: function () {
          this.distOrigenCargando = false,
          this.ubigeoOrigenDom = this.departamentoSeleccionadoUbigeoOrigen + this.provinciaSeleccionadaUbigeoOrigen + this.distritoSeleccionadoUbigeoOrigen.codDistrito,
          this.prependUbigeoOrigen = this.distritoSeleccionadoUbigeoOrigen.nombre,
          this.bloqueUbigeoPartida = true
        },
        departamentoSeleccionadoUbigeoDestino: function () {
          this.provDestino = true,
          this.searchProvinceDestino(1)
        },
        provinciaSeleccionadaUbigeoDestino: function () {
          this.distDestino = true,
          this.distDestinoCargando = true,
          this.searchDistrictDestino(this.distDestinoCargando, 1)
        },
        distritoSeleccionadoUbigeoDestino: function () {
            this.distDestinoCargando = false,
            this.ubigeoDestinoDom = this.departamentoSeleccionadoUbigeoDestino + this.provinciaSeleccionadaUbigeoDestino + this.distritoSeleccionadoUbigeoDestino.codDistrito,
            this.prependUbigeoDestino = this.distritoSeleccionadoUbigeoDestino.nombre
        },
    },
    methods: {
        valorUnitIsc(){
        if(this.montoISC !=''){
            let convertirISC = '';
            let impuestoISC = '';
            let impuestoIGV = '';
            let suma = '';

            if(this.selectedISC == 1 ){
              this.valorUniSinIsC = this.valorUnitario
              convertirISC = this.montoISC/100;
              impuestoISC = parseFloat(this.valorUnitario * convertirISC);
              impuestoIGV = (this.valorUnitario + impuestoISC)*(this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
              suma = this.valorUnitario + impuestoISC;
              this.valorUnitario = suma;
              
            }else if(this.selectedISC == 2){
              this.valorUniSinIsC = this.valorUnitario
              impuestoISC = this.montoISC
              suma = parseFloat(this.valorUnitario) + parseFloat(impuestoISC);
              this.valorUnitario = suma;
            
            }else if(this.selectedISC == 3){
               this.valorUniSinIsC = this.valorUnitario
              this.valorSugerido = parseFloat(this.montoISC) * parseFloat(this.porcentajeISC/100);
              suma = (this.valorSugerido) + (this.valorUnitario);
              this.valorUnitario = suma;
              
            }
          }else if(this.montoISC == ''){
            // this.precioVentaUnitario = ''
          }
          this.cuadroISC = false;
          this.flechaISC = true;
        },
        mostrarISC(){
            this.flechaISC = false;
            this.cuadroISC = true;
        },
        onChange(event) {
            this.file = event.target.files ? event.target.files[0] : null;
        },
        onChange2(event) {
            this.guiasdoc = event.target.files ? event.target.files[0] : null;
        },
        totalitems(value){
            this.items = value
            this.action.i = false
            this.action.b = false
            this.action.z = false
        },
        totalitems2(value){
            this.guiasRelacionada = value
            this.action.i = false
        },
        cargarItems(){
            let valor = false
            this.ListProductos.forEach(function(element){
                if(element.cantidad > 0){
                    valor = true
                }
            })
            if(valor){
                this.subirItems = true
                this.itemsModal = this.ListProductos.filter(x => x.cantidad > 0)
                this.itemsEX = this.itemsModal
                this.action.i = true 
                this.searchItems = false
            }else{
                this.$snotify.warning("Debe agregar una cantidad","Cuidado")
            }
        },
        addUnidad(data){
            let array = []
            let item = data
            let cantidad = data.cantidad
            if(cantidad == ''){
            item.cantidad = 1
            array.push(item)
            this.itemsEX = array
            this.action.i = true
            this.codDescripcion ='' 
            }else{
            array.push(item)
            this.itemsEX = array
            this.action.i = true 
            }
        },
        quickEmisionProforma: function () {
            let itemBlank = []
            this.bufferOrdenpago = this.$store.getters.getordenpago
            this.bufferProforma = this.$store.getters.getproforma
            this.bufferBoleta = this.$store.getters.getboleta
            let array = {
                items: this.bufferBoleta
            }
            if (Object.values(this.bufferProforma).length > 0){
                this.tipoDocumento = this.bufferProforma.proforma.receptor.tipo
                this.receptor.numero = this.bufferProforma.proforma.receptor.nro
                this.receptor.razonSocial = this.bufferProforma.proforma.receptor.razonSocial
                this.receptor.direccion = this.bufferProforma.proforma.receptor.direccionFiscal
                this.items = this.bufferProforma.proforma.items
                this.moneda = this.bufferProforma.proforma.moneda
                this.$store.commit('setproforma', itemBlank)
            } 
            if (Object.values(this.bufferOrdenpago).length > 0)
             {
                this.tipoDocumento = this.bufferOrdenpago.ordenPago.receptor.tipo
                this.receptor.numero = this.bufferOrdenpago.ordenPago.receptor.nro
                this.receptor.razonSocial = this.bufferOrdenpago.ordenPago.receptor.razonSocial
                this.receptor.direccion = this.bufferOrdenpago.ordenPago.receptor.direccionFiscal
                this.items = this.bufferOrdenpago.ordenPago.items
                this.moneda = this.bufferOrdenpago.ordenPago.moneda
                this.idOrdenPago = this.bufferOrdenpago.idOrdenPago
                this.$store.commit('setordenpago', itemBlank)
            }else if(this.bufferBoleta){
                this.itemsEXz = array.items
                this.action.z = true
                this.$store.commit('setboleta', itemBlank)
            }
        },
        cerrarmodalOtroCargo: function () {
            this.otroscargosmodal = false
        },
        cerrarmodaldsctGlobal(){
            this.descuentoglobalM = false;
        },
        accumulateOtrosCargos: function () {
            let val = 0.00
            this.listaOtrosCargosAgregados.forEach(function(element) {
                val += parseFloat(element.montoCargoDescuento);
            });
            this.sumatoriaOtrosCargos = val
            return this.sumatoriaOtrosCargos.toFixed(2)
        },
        deleteOtroCargo: function (index, value) {
            this.$swal({
                title: 'Eliminar Otro Cargo',
                text: 'Seguro de eliminar el cargo con monto '+value.montoCargoDescuento,
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                this.listaOtrosCargosAgregados.splice(index,1)
                }
            })
        },
        addMontoCargo: function () {
            this.v1 = parseFloat(this.montoOtroCargo)
            let otrocargo = {
                // codigoMotivoCargo: this.otroCargo.codigo,
                // factorNumericoCargo: parseFloat((this.montoOtroCargo*100)/this.importeTotal),
                // montoCargo: parseFloat(this.montoOtroCargo),
                // montoBaseCargo: this.baseCargo,
                indicador: "cargo",
                codigoCargoDescuento: this.otroCargo.codigo,
                factorCargoDescuento: parseFloat(((this.montoOtroCargo)/this.importeTotal).toFixed(5)),
                montoCargoDescuento: parseFloat(this.v1.toFixed(2)),
                baseCargoDescuento: parseFloat((this.baseCargo).toFixed(2))
            }
            if(this.montoOtroCargo > 0){
                this.listaOtrosCargosAgregados.push(otrocargo)
                this.montoOtroCargo = ''
            }else{
                this.$snotify.warning('El monto debe ser mayor a 0','Cuidado')
            }
        },
        validateOtrosCargos: function () {
            if(this.listaOtrosCargosAgregados.length > 0){
                return false
            }else{
                return true
            }
        },
        buscarRazonSocial: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros/razonsocial', {
                token: this.$store.getters.userToken,
                q: this.publicogeneral
            })
            .then(response => {})
            .catch(error => {})
        },
        backEmision(value) {
            if(value === 0){
                this.postEmision = false
            }else if(value != 0){
                this.idDocumentPreview = value
                this.tipoDocPreview = 2
                this.postEmision = true
                this.initTicket()
            }
        },
        sendPreviw: function (value) {
            if(!value){
                this.previwEmit = true
                this.postEmision = false
            }else{
                this.postEmision = true
                this.typeInvoice == '1' ? this.validadorseries = this.listaSeries.length : this.validadorseries = -1
                if(this.validadorseries == 0){
                    this.$snotify.warning('Verifique que tenga una serie valida y que haya seleccionado un receptor!', 'Cuidado'),
                    this.previwEmit = false
                }else{
                    this.previwEmit = false
                }
            }
        },
        getSeries: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/'+ this.tipodoc, {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data, 
                this.rolSeries = response.data.rol,
                this.seriesCargadas = false,
                this.igvGlobal = response.data.igv
                ))
            .catch(error => {
                this.seriesCargadas = false
            })
        },
        // serieLocal(){
        //     this.listaSeries = this.$store.getters.getSerieBol
        //     this.igvGlobal = this.$store.getters.getIgvGlobal;
        // },
        enableFieldsReceptor: function () {
            this.habilitado = false
        },
        setReceiver: function (item) {
            this.receptor.numero = item.idReceptor,
            this.receptor.tipo = item.tipo,
            this.receptor.razonSocial = item.razonSocial,
            this.receptor.direccion = item.direccionReferencia,
            this.direcciones = item.direcciones,
            this.listaCorreos = item.email,
            this.listarec = false,
            this.listaReceptores = [],
            this.tipoDocumento = item.tipo
        },
        setReceiverdni(item){
            this.receptor.razonSocial = item.nombre
            this.mostrardni = false
            this.listarec = false
            this.listaReceptores = []
        },
        changeDirection: function () {
            this.verDirecciones = !this.verDirecciones
        },
        setDirection: function (value) {
            this.receptor.direccion = value.direccion,
            this.verDirecciones = false
        },
        setReceiverProductCode: function (item) {
            this.idProducto = item.idProducto,
            this.codigoProducto = item.codigo,
            this.descripcion = item.descripcion,
            this.codigoSunatBarras = item.codigoProductoSunat,
            this.precioVentaUnitario = item.precioUnitario,
            this.unidadMedidaCantidad = item.unidadMedida
            if(item.tipoAfectacionIgv == ''){
                this.especificacionIgv = '01'
            }else{
                this.especificacionIgv = item.tipoAfectacionIgv
            }
            this.listarecProduct = false,
            this.listaReceptoresProductCode = []
        },
        setReceiverCodeBarrasSunat: function (item) {
            this.idProducto = item.idProducto,
            this.codigoProducto = item.codigo,
            this.descripcion = item.descripcion,
            this.codigoSunatBarras = item.codigoProductoSunat,
            this.precioVentaUnitario = item.precioUnitario,
            this.unidadMedidaCantidad = item.unidadMedida
            if(item.tipoAfectacionIgv == ''){
                this.especificacionIgv = '01'
            }else{
                this.especificacionIgv = item.tipoAfectacionIgv
            }
            this.listarecProductBarrasSunat = false,
            this.listaReceptoresCodeBarrasSunat = []
        },
        agregarItem(item){
            this.setReceiverDescription(item)
        },
        setReceiverDescription: function (item) {  
            this.itemEditado = false,
            this.stock = item.stock
            this.idProducto = item.idProducto,
            this.codigoProducto = item.codigo,
            this.descripcion = item.descripcion,
            this.codigoSunatBarras = item.codigoProductoSunat,
            this.precioVentaUnitario = item.precioUnitario,
            this.unidadMedidaCantidad = item.unidadMedida
            if(item.tipoAfectacionIgv == ''){
                this.especificacionIgv = '01'
            }else{
                this.especificacionIgv = item.tipoAfectacionIgv
            }
            this.listades = false,
            this.listaDescription = []
            if(item.isc !='' && item.isc != null){
                this.isc = true;
                this.selectedISC = item.isc.tipoISC;
                if(item.isc.tipoISC == 3){
                    this.montoISC = item.isc.valorReferencial
                    this.porcentajeISC = item.isc.valorISC
                }else{
                    this.montoISC = item.isc.valorISC
                }
            } 
        },
        initIgv: function () {
            if(this.especificacionIgv === '01'){
                this.Especificacion = this.EspecificacionIgv
            }
            else if(this.especificacionIgv === '02'){
                this.Especificacion = this.EspecificacionIgv2
            }
            else if(this.especificacionIgv === '03'){
                this.Especificacion = this.EspecificacionIgv3
            }
        },
        initDates: function () {
            if(this.typeTicket == 1){
            let r1 = {
                from: this.$moment().subtract(50000,'years'),
                to: this.$moment().subtract(4,'days')
            }
            let r2 = {
                from: this.$moment().add(0,'days'),
                to: this.$moment().add(60000,'years')
            }
            this.diasnopermitidos.ranges.splice(r1);
            this.diasnopermitidos.ranges.splice(r2);
            this.diasnopermitidos.ranges.push(r1)
            this.diasnopermitidos.ranges.push(r2)
            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
            }else{
            let r1 = {
                from: this.$moment().subtract(50000,'years'),
                to: this.$moment().subtract(1791,'days')
            }
            let r2 = {
                from: this.$moment().add(0,'days'),
                to: this.$moment().add(60000,'years')
            }
            this.diasnopermitidos.ranges.splice(r1);
            this.diasnopermitidos.ranges.splice(r2);
            this.diasnopermitidos.ranges.push(r1)
            this.diasnopermitidos.ranges.push(r2)
            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
            }          
        },
        initMoneda: function () {
            this.moneda = {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
            }
        },
        validateFields: function () {
            let itemsGenerales = false;
            if(this.cantidad!='' && this.descripcion!='' && this.precioVentaUnitario!==''){
                itemsGenerales = true;
            }else{
                itemsGenerales = false;
            }
            if(itemsGenerales && this.tipoOperacion == "0101EDU" && 
                              this.aula != "" && 
                              this.gradoYseccion != "" && 
                              this.dniAlumno != "" &&
                              this.nomApeAlumno != "" &&
                              this.ubigeoOrigenDom != "" &&
                              this.direccionDomAlumno != "" &&
                              this.ubigeoDestinoDom != "" &&
                              this.direccionColegio != "" &&
                              this.periodoAcademido != "" ){
            return true;
          }
          if(itemsGenerales && (this.tipoOperacion == "0101"|| this.tipoOperacion == "0112" || this.tipoOperacion == "0113")){
            return true
          }else{
            return false
          }
        },
        validateFieldsGuia: function () {
            if(this.seriedeguia.length == 4 && this.numerodeguia!='' && this.tipodeguia!==''){
                return true
            }else{
                return false
            }
        },
        validateFieldsAdicionales: function () {
            if(this.key!='' && this.value!=''){
                return true
            }else{
                return false
            }
        },
        validateTicket: function () {
            let tiposerie = ''
            this.typeInvoice == '1' ? this.validadorseries = this.listaSeries.length : this.validadorseries = -1
            if(this.typeTicket == 1){
                if(this.indexSerie == 0){
                    this.serie = this.listaSeries[0]
                    tiposerie = this.serie
                }else{
                    this.serie = this.listaSeries[this.serie]
                    tiposerie = this.serie
                }
            }else if(this.typeTicket == 2){
                tiposerie = this.seriecon
            }
            if(this.receptor.idReceptor!=='' && tiposerie!==''  && this.items.length>0 && !this.seriesCargadas && this.validadorseries != 0){
                return true
            }
            else{
                return false
            }
        },
        accumulateIgv: function () {
            let val = 0.00
            let val2 = 0.0;
            let valGratuita = 0.00
            let codtributo = 0.0;
            this.items.forEach(function(element) {
                if(element.codigoTributo == '9996' && element.tipoPrecioVentaUnitario == '02'){
                valGratuita += parseFloat(element.montoTotalImpuestosItem);
                }else{
                val += parseFloat(element.montoTotalImpuestosItem);
                val2 += parseFloat(element.montoAfectacionIgv);
                }
                codtributo = element.codigoTributo
            });
            if(this.selectedAnticipos.length > 0 && this.totalAnticiposIgv > 0){
                this.montoTotalImpuestos = val - this.totalAnticiposIgv;
                this.sumatoriaIgv = val2 - this.totalAnticiposIgv;
            }else if(this.valorGlobal >0){
                this.montoTotalImpuestos = (val - (this.valorGlobal*(this.$store.state.igv == 18 ? 0.18 : 0.105))), //0.18
                this.sumatoriaIgv =  (val2 - (this.valorGlobal*(this.$store.state.igv == 18 ? 0.18 : 0.105))); //0.18
                val2 = this.sumatoriaIgv;
                val = this.montoTotalImpuestos
            }else{
                (this.montoTotalImpuestos = val), 
                (this.sumatoriaIgv = val2);
            }
            this.cotributo = codtributo;
            // this.montoTotalImpuestos = val,
            // this.sumatoriaIgv = val,
            this.sumatoriaIgvGratuitas = valGratuita
            return val.toFixed(2)
        },
        accumulateTaxes: function () {
            var val = 0.00;
                this.items.forEach(function(element) {
                    val += parseFloat(element.montoAfectacionIgv);
            });
            this.sumatoriaIgv = val.toFixed(4)
        },
        accumulateRecordedSale: function () {
            var val = 0.00
            let valGrabadaAnticipos = 0.0;
                this.items.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '10'){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.selectedAnticipos.forEach(function(element) {
                if (element.tipoAfectacion == 10) {
                    valGrabadaAnticipos += parseFloat(element.montoAnticipadoValor);
                }
            });
            if(this.selectedAnticipos.length > 0 && valGrabadaAnticipos > 0){
                this.totalVentaGravada = val;
                this.valGrabadaAnticipos = valGrabadaAnticipos;
            }else if(this.valorGlobal > 0){
                 this.totalVentaGravada = val - this.valorGlobal;
                val = this.totalVentaGravada;
            }else{
                this.totalVentaGravada = val
            } 
            return val.toFixed(2)

        },
        accumulateExoneratedSale: function () {
            var val = 0.00;
            let valExoneradoAnticipos = 0.0;
            this.items.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '20'){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.selectedAnticipos.forEach(function(element) {
                if (element.tipoAfectacion == 20) {
                    valExoneradoAnticipos += parseFloat(element.montoAnticipadoExonerado);
                }
            });
            if (this.selectedAnticipos.length > 0 && valExoneradoAnticipos > 0) {
                this.totalVentaExonerada = val - valExoneradoAnticipos;
                this.totalVentaExonerada2 = val;
            }else{
                this.totalVentaExonerada = val;
                this.totalVentaExonerada2 = val;
            }
            return val.toFixed(2)
        },
        accumulateUnaffectedSale: function () {
            var val = 0.00;
            let valInafectaAnticipos = 0.0;
                this.items.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '30'){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.selectedAnticipos.forEach(function(element) {
                if (element.tipoAfectacion == 30) {
                    valInafectaAnticipos += parseFloat(element.montoAnticipadoInafecto);
                }
            });
            if (this.selectedAnticipos.length > 0 && valInafectaAnticipos > 0) {
                this.totalVentaInafecta = val - valInafectaAnticipos;
                 this.totalVentaInafecta2= val;
            }else{
                this.totalVentaInafecta = val;
                 this.totalVentaInafecta2= val;
            }
            return val.toFixed(2)
        },
        accumulateFreeSale: function () {
            var val = 0.00
                this.items.forEach(function(element) {
                    if(element.tipoAfectacionIgv == '11' ||
                       element.tipoAfectacionIgv == '12' ||
                       element.tipoAfectacionIgv == '13' ||
                       element.tipoAfectacionIgv == '14' ||
                       element.tipoAfectacionIgv == '15' ||
                       element.tipoAfectacionIgv == '16' ||
                       element.tipoAfectacionIgv == '31' ||
                       element.tipoAfectacionIgv == '32' ||
                       element.tipoAfectacionIgv == '33' ||
                       element.tipoAfectacionIgv == '34' ||
                       element.tipoAfectacionIgv == '35' ||
                       element.tipoAfectacionIgv == '36' ||
                       element.tipoAfectacionIgv == '21'
                        ){
                        val += parseFloat(element.valorVenta);
                    }
            });
            this.totalVentaGratuita = val
            return val.toFixed(2)
        },
        accumulateExportSale: function () {
            var val = 0.00;
            this.items.forEach(function(element) {
            if(element.tipoAfectacionIgv == '40'){
                val += parseFloat(element.valorVenta);
            }
            });
            this.totalVentaExportacion = val
            return val.toFixed(2)
        },
        accumulateTotalSale: function () {
            var val = 0.00
            if(this.totalVentaGravada != 0 || this.totalVentaInafecta != 0 || this.totalVentaExonerada != 0 || this.accumulateICBPER() != 0){
                this.importeTotal = this.montoTotalImpuestos + this.totalVentaGravada + this.totalVentaInafecta + this.totalVentaExonerada + this.sumatoriaOtrosCargos + this.accumulateICBPER() - this.valGrabadaAnticipos
                this.baseCargo = this.importeTotal - this.sumatoriaOtrosCargos
            }else{
                this.importeTotal = 0
                this.baseCargo = 0
            }
            val = this.importeTotal
            return val.toFixed(2)
        },
        accumulateDescuento: function () {
            var val = 0.00;
                this.items.forEach(function(element) {
                    val += parseFloat(element.descuento);
            });
            this.totalDescuentosAcumulados = val
            return val.toFixed(2)
        },
        addDescuentosGlobales(){
          let desctglobal = {
            indicador: "",
            codigoCargoDescuento: "",
            factorCargoDescuento:"",
            montoCargoDescuento: "",
            baseCargoDescuento: ""
          }
          let valorDes ={
            monto:""
          }
            if(this.descuentoItemMontoG != "" || this.descuentoItemPorcentajeG != ""){
                this.valorGlobal = this.descuentoItemMontoG / (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18 
                desctglobal.indicador = "descuento",
                desctglobal.codigoCargoDescuento = "02"
                desctglobal.factorCargoDescuento = parseFloat((this.valorGlobal / this.valortotal()).toFixed(5));              
                desctglobal.baseCargoDescuento = parseFloat(this.valortotal().toFixed(2));
                desctglobal.montoCargoDescuento = parseFloat(((desctglobal.factorCargoDescuento)*desctglobal.baseCargoDescuento).toFixed(2))
                this.cargosDescuentosGlobales.push(desctglobal)
                this.$snotify.success("Descuento Agregado");

                valorDes.monto = this.descuentoItemMontoG
                this.listarMontos.push(valorDes)   
             }else{
                this.$snotify.warning("El monto debe ser mayor a 0", "Cuidado");
            }
                this.gravado = true
        },
        borrarDescuento: function (index) {
            this.listarMontos.splice(index,1)
            this.cargosDescuentosGlobales.splice(index,1)
            if(this.listarMontos.length <= 0){
              this.descuentoItemMontoG = ''
              this.valorGlobal = ''
              this.cargosDescuentosGlobales = []
              this.listarMontos = []
              this.gravado = false
            }        
        },
        accumulatedescuentoG(){
            let val = 0.0;
            this.cargosDescuentosGlobales.forEach(function(element) {
                if(element.codigoCargoDescuento == '02'){
                    val = parseFloat(element.montoCargoDescuento);
                }
            });
            return val.toFixed(2);
        },
        valortotal(){
                let val = 0.0;
                this.items.forEach(function(element){
                    if(element.valorTotal !=''){
                         val += parseFloat(element.valorVenta);
                    }
                })
                return val;
         },
        calcItem: function () {
            var parent = this;
            if(parent.especificacionIgv === '01' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv
                parent.especificacion = {
                    codigo: '10',
                    descripcion: 'Operacion onerosa',
                    codigoTributo: '1000'
                }
                parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
            }
            else if(parent.especificacionIgv === '01' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
                
            }
            else if(parent.especificacionIgv === '02' && !parent.vunitario){
                    parent.Especificacion = parent.EspecificacionIgv2
                    parent.especificacion = {                
                                codigo: '30',
                                descripcion: 'Operación Onerosa',
                                codigoTributo: '9998'		
                            }      
                    parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '02' && parent.vunitario){
                    parent.precioVentaUnitario = parent.valorUnitario
            }
            else if(parent.especificacionIgv === '03' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv3
                parent.especificacion = {                
                            codigo: '20',
                            descripcion: 'Operación Onerosa',
                            codigoTributo: '9997'		
                        }      
                parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '03' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario
            }

        },
        calcItemGratuitos: function () {
            var parent = this;
            if(parent.especificacionIgv === '01' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv
                parent.especificacion = {
                    codigo: '15',
                    descripcion: 'Grabado - Bonificaciones',
                    codigoTributo: '9996'
                }
                parent.valorUnitario = parent.precioVentaUnitario / (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
            }
            else if(parent.especificacionIgv === '01' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario * (this.$store.state.igv == 18 ? 1.18 : 1.105) ; //1.18
            }
            else if(parent.especificacionIgv === '02' && !parent.vunitario){
                    parent.Especificacion = parent.EspecificacionIgv2
                    parent.especificacion = {
                                codigo: '31',
                                descripcion: 'Retiro por Bonificación',
                                codigoTributo: '9996'
                            }
                    parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '02' && parent.vunitario){
                    parent.precioVentaUnitario = parent.valorUnitario
            }
            else if(parent.especificacionIgv === '03' && !parent.vunitario){
                parent.Especificacion = parent.EspecificacionIgv3
                parent.especificacion = {
                            codigo: "21",
                            descripcion: "Transferencia gratuita",
                            codigoTributo: "9996"
                        }
                parent.valorUnitario = parent.precioVentaUnitario
            }
            else if(parent.especificacionIgv === '03' && parent.vunitario){
                parent.precioVentaUnitario = parent.valorUnitario
            }
        },
        accumulateICBPER: function () {
            let total = 0.0
            this.items.forEach(function(element){
            if(element.afectoIcbper){
                    total = total + (0.50 * element.cantidad)
                }
            })
            return total;
            
        },
        addItem: function () {
            let tasabolsa = 0
            let item ={
                baseAfectacionIgv: '',
                adicional: {
                    indicardorDsct:'',
                    dsctSoles:'',
                    dsctPorcentaje:'',
                    precioVentaUni:'',
                    precioTotalIGV:0.00,
                    transporteTerrestrePasajeros: {}
                },
                cargosDescuentosItem:[{}],
                iscOtrosTributosItem:[]
            }
            item.stock = this.stock
            item.valorVentaSinAfectar = this.valorUnitario*this.cantidad
            item.tipoAfectacionIgv = this.especificacion.codigo
            if(this.tipoOperacion == '0200'){
                item.codigoTributo = '9995'
                item.tipoAfectacionIgv = '40'
            }else{
                item.codigoTributo = this.especificacion.codigoTributo
            }
            if(this.codigoProducto != ''){
                item.codigoProducto = this.codigoProducto
            }
            if(!this.vbarras){
                item.codigoProductoSunat = this.codigoSunatBarras
            }else{
                item.codigoProductoGs1 = this.codigoProductoGs1
            }
            item.idProducto = this.idProducto
            item.unidadMedidaCantidad = this.unidadMedidaCantidad
            item.cantidad = parseFloat(this.cantidad)
            item.descripcion = this.descripcion
            item.valorUnitario = parseFloat(this.valorUnitario).toFixed(10)

            if( 
                this.especificacion.codigo == '10' || 
                this.especificacion.codigo == '20' || 
                this.especificacion.codigo == '30'
            ){
                item.tipoPrecioVentaUnitario = '01';
            }
            else{
                item.tipoPrecioVentaUnitario = '02';
            }
            if(this.descuentoItemMonto != '' && this.especificacionIgv == "01"){
                item.adicional.indicardorDsct = '01'
                item.adicional.dsctSoles = parseFloat(this.descuentoItemMonto)
                item.descuento = parseFloat(parseFloat(this.descuentoItemMonto / (this.$store.state.igv == 18 ? 1.18 : 1.105)).toFixed(10)) //1.18
                item.porcentajeDescuento = parseFloat(this.descuentoItemMonto / (this.$store.state.igv == 18 ? 1.18 : 1.105)) / item.valorVentaSinAfectar //1.18
            }else if( this.descuentoItemMonto != "" && (this.especificacionIgv == "02" || this.especificacionIgv == "03")){
                item.adicional.dsctSoles = parseFloat(this.descuentoItemMonto)
                item.adicional.indicardorDsct = '01'
                item.descuento = parseFloat(this.descuentoItemMonto).toFixed(10);
                item.porcentajeDescuento = parseFloat(this.descuentoItemMonto) / item.valorVentaSinAfectar;
                this.inafecto = (item.valorVentaSinAfectar  - this.descuentoItemMonto)/item.cantidad;
            }else if(this.descuentoItemPorcentaje != ""){
                item.adicional.indicardorDsct = '02'
                item.adicional.dsctPorcentaje = parseFloat(this.descuentoItemPorcentaje)
                item.descuento = (
                    (this.descuentoItemPorcentaje/100) * 
                    item.valorUnitario * 
                    item.cantidad
                    ).toFixed(10);
                item.porcentajeDescuento =this.descuentoItemPorcentaje / 100;
            }else{
                item.descuento = parseFloat(0.00)
                item.porcentajeDescuento = parseFloat(0.0);
                delete item.cargosDescuentosItem;
                item.cargosDescuentosItem = []
            }
            if(item.descuento == 0){
                item.baseAfectacionIgv = item.valorUnitario*item.cantidad
                delete item.cargosDescuentosItem;
                item.cargosDescuentosItem = []
            }else{
                item.baseAfectacionIgv = item.valorUnitario*item.cantidad-item.descuento
            }
            if(this.ventaGratuita){
                item.valorUnitario = parseFloat((0.00).toFixed(10))
                item.valorUnitarioVista = parseFloat(parseFloat(this.valorUnitario).toFixed(10))
                
                item.valorVenta = parseFloat(this.precioVentaUnitario * this.cantidad)

                item.valorVentaVista = parseFloat((0.00).toFixed(10))

                item.baseAfectacionIgv = this.precioVentaUnitario * this.cantidad;
                item.montoAfectacionIgv = item.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105);  //0.18
                item.montoTotalImpuestosItem = parseFloat(0.0);
            }else{
                item.valorUnitario = parseFloat(parseFloat(this.valorUnitario).toFixed(10))
                item.valorUnitarioVista = parseFloat(item.valorUnitario)
                item.valorVenta = parseFloat(item.baseAfectacionIgv.toFixed(10))
                item.valorVentaVista = parseFloat(item.valorVenta)
            }
            // item.valorVenta = item.baseAfectacionIgv.toFixed(10)
            if(this.especificacionIgv == '01' && this.ventaGratuita == false){               
                item.montoAfectacionIgv = parseFloat((item.baseAfectacionIgv * (this.$store.state.igv == 18 ? 0.18 : 0.105)).toFixed(10)) //0.18
                item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv)
            }else if(this.especificacionIgv == '02'){
                item.montoAfectacionIgv = parseFloat((0.00).toFixed(10))
                item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv)
            }else if(this.especificacionIgv == '03'){
                item.montoAfectacionIgv = parseFloat((0.00).toFixed(10))
                item.montoTotalImpuestosItem = parseFloat(item.montoAfectacionIgv)
            }
            item.porcentajeImpuesto = (this.$store.state.igv == 18 ? 18 : 10.5); //18

            item.adicional.precioVentaUni = parseFloat(this.precioVentaUnitario)
            item.precioVentaUnitario = parseFloat(this.precioVentaUnitario)
            // ISC
            if(this.isc){
            if(this.selectedISC == 1){
                let valorVentaTipo1  = this.valorUniSinIsC * item.cantidad
                let igvTipo1 = valorVentaTipo1 * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                let iscValor = (this.montoISC/100) * valorVentaTipo1;
                let impuesto1 =  ((valorVentaTipo1 + iscValor) * (this.$store.state.igv == 18 ? 0.18 : 0.105)) + iscValor ; //0.18
                let precioISC = this.precioVentaUnitario * (this.montoISC/100);
                let precioSumaISC = parseFloat(this.precioVentaUnitario) + parseFloat(precioISC);
    ;           item.precioVentaUnitario = parseFloat(precioSumaISC);
                item.valorVenta = valorVentaTipo1
                item.valorUnitario = this.valorUniSinIsC      

                let baseAfecta1 = (valorVentaTipo1 * (this.montoISC/100)) + valorVentaTipo1;
                let montoAfecta1 = (valorVentaTipo1 + iscValor)*(this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18

                item.montoTotalImpuestosItem = parseFloat(parseFloat(impuesto1).toFixed(2));
                item.baseAfectacionIgv = parseFloat(parseFloat(baseAfecta1).toFixed(2))
                item.montoAfectacionIgv = parseFloat(parseFloat(montoAfecta1).toFixed(2))
            }else if(this.selectedISC == 2){
                let valorVentaTipo2 = this.valorUniSinIsC * item.cantidad;
                let precioUniConISC = (parseFloat(this.montoISC/100) * parseFloat(this.precioVentaUnitario)) + parseFloat(this.precioVentaUnitario);
                let nuevoValorVenta = parseFloat(valorVentaTipo2) + parseFloat(this.montoISC)
                
                item.precioVentaUnitario = parseFloat(precioUniConISC)
                item.valorVenta = valorVentaTipo2
                item.valorUnitario = this.valorUniSinIsC
                //montoTotalImpuestosItem
                let igvTipo2 = parseFloat(this.precioVentaUnitario) * (this.montoISC/100);
                let impuestosISC = parseFloat(igvTipo2) * (this.cantidad);
                let valor3 = parseFloat(valorVentaTipo2) * (this.$store.state.igv == 18 ? 0.18 : 0.105);  //0.18
                let sumaValoresIGV = parseFloat(impuestosISC) + parseFloat(valor3);
                item.montoTotalImpuestosItem =  parseFloat(sumaValoresIGV);

                //baseAfectacionIgv
                let baseAfecta2 = parseFloat(this.valorUniSinIsC) * parseFloat(this.cantidad);
                let vBase = parseFloat(baseAfecta2) * (this.montoISC/100);
                let sumaBase = parseFloat(baseAfecta2) + parseFloat(vBase);
                item.baseAfectacionIgv = parseFloat(sumaBase);

                //montoAfectacionIgv
                let montoAfecta = parseFloat(valorVentaTipo2 * (this.$store.state.igv == 18 ? 0.18 : 0.105));  //0.18
                let montoAfecta2 = parseFloat(montoAfecta)* parseFloat(this.montoISC/100);//1.8
                let sumaAfecta2 = parseFloat(montoAfecta) + parseFloat(montoAfecta2);
                item.montoAfectacionIgv = parseFloat(parseFloat(sumaAfecta2).toFixed(2));
            }else if(this.selectedISC == 3){
                let valorVen = this.valorUniSinIsC * item.cantidad;

                let precioUniISC = (parseFloat(this.valorSugerido/100) * parseFloat(this.precioVentaUnitario)) + parseFloat(this.precioVentaUnitario);
                item.precioVentaUnitario = parseFloat(precioUniISC);
                let valorVentaTipo3 = this.valorUniSinIsC * item.cantidad;
                item.valorVenta = valorVentaTipo3;
                item.valorUnitario = this.valorUniSinIsC
                //montoTotalImpuestosItem3
                let vI1 = parseFloat(this.precioVentaUnitario) * (this.valorSugerido/100);
                let vI2 = parseFloat(vI1) * (this.cantidad);
                let vI3 = parseFloat(valorVen) * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                let sumaMI = parseFloat(vI2) + parseFloat(vI3);
                item.montoTotalImpuestosItem =  parseFloat(sumaMI);
                //baseAfectacionIgv3
                let vBA1 = parseFloat(this.valorUniSinIsC) * parseFloat(this.cantidad);
                let vBA2 = parseFloat(vBA1) * (this.valorSugerido/100);
                let sumaBA = parseFloat(vBA1) + parseFloat(vBA2);
                item.baseAfectacionIgv = parseFloat(sumaBA);
                //montoAfectacionIgv
                let vMA1 = parseFloat(valorVen * (this.$store.state.igv == 18 ? 0.18 : 0.105)); //0.18
                let vMA2 = parseFloat(vMA1) * parseFloat(this.valorSugerido/100);
                let sumaMA = parseFloat(vMA1) + parseFloat(vMA2);
                item.montoAfectacionIgv = parseFloat(parseFloat(sumaMA).toFixed(2));
            }
                let iscItems = {
                    baseTributo:"",
                    montoTributo:"",
                    tasaTributo: "",
                    tipoSistemaIsc: "",
                    codigoTributo: "2000"             
                }
                if(this.selectedISC == 1 || this.selectedISC == 2){
                    iscItems.baseTributo = parseFloat((item.valorVenta).toFixed(2))
                    iscItems.montoTributo = parseFloat((item.valorVenta * (this.montoISC/100)).toFixed(2))              
                    iscItems.tasaTributo = parseFloat(this.montoISC)
                }else if(this.selectedISC == 3){
                    iscItems.baseTributo = parseFloat(this.montoISC) * parseFloat(this.cantidad)
                    iscItems.tasaTributo = parseFloat(this.porcentajeISC)
                    iscItems.montoTributo = parseFloat(((iscItems.baseTributo * iscItems.tasaTributo)/100).toFixed(2))                                  
                }
                iscItems.tipoSistemaIsc = this.iscCodigo,
                item.iscOtrosTributosItem.push(iscItems)
                this.montoISC = '';
                this.porcentajeISC = '';
                this.isc = false;
                item.adicional.precioTotalIGV = parseFloat(item.valorVenta) + parseFloat(item.montoTotalImpuestosItem);
            }else{
              delete item.iscOtrosTributosItem
            }
            if(this.tipoOperacion =="0101EDU"){
                item.adicional.transporteTerrestrePasajeros.numeroAsiento = this.aula;
                item.adicional.transporteTerrestrePasajeros.informacionManifiesto = this.gradoYseccion;
                item.adicional.transporteTerrestrePasajeros.tipoDocumentoPasajero = "1";
                item.adicional.transporteTerrestrePasajeros.numeroDocumentoPasajero = this.dniAlumno;
                item.adicional.transporteTerrestrePasajeros.nombresApellidosPasajero = this.nomApeAlumno;
                item.adicional.transporteTerrestrePasajeros.ubigeoLugarOrigen = this.ubigeoOrigenDom;
                item.adicional.transporteTerrestrePasajeros.direccionDetalladaOrigen = this.direccionDomAlumno;
                item.adicional.transporteTerrestrePasajeros.ubigeoLugarDestino = this.ubigeoDestinoDom;
                item.adicional.transporteTerrestrePasajeros.direccionDetalladaDestino = this.direccionColegio;
                item.adicional.transporteTerrestrePasajeros.fechaInicioProgramado = this.$moment(this.periodoAcademido).format("YYYY-MM-DD")
            }
            if(item.descuento != 0){

            if(this.descuentoItemMonto != "" &&(this.especificacionIgv == "02" || this.especificacionIgv == "03")){
                item.precioVentaUnitario = this.inafecto; 
                item.cargosDescuentosItem[0].indicador= "descuento";
                (item.cargosDescuentosItem[0].codigoCargoDescuento= "00");
                (item.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento).toFixed(5)));
                item.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(item.descuento).toFixed(2));
                item.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(item.valorVentaSinAfectar).toFixed(2));
            }else{
                if(this.descuentoItemMonto != '' || this.descuentoItemPorcentaje != "" && this.especificacionIgv == "01"){
                this.montoValorUnitario2 = ( item.valorUnitario - (item.descuento/item.cantidad));
                this.montoIgvGlobal = this.montoValorUnitario2 * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                item.precioVentaUnitario = this.montoValorUnitario2 + this.montoIgvGlobal;
                item.cargosDescuentosItem[0].indicador= "descuento";
                (item.cargosDescuentosItem[0].codigoCargoDescuento= "00");
                (item.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento).toFixed(5)));
                item.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(item.valorVentaSinAfectar).toFixed(2));
                item.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento * item.valorVentaSinAfectar).toFixed(2));
                }else if(this.descuentoItemPorcentaje != ""){
                this.montoValorUnitario2 = ( item.valorUnitario - (item.descuento/item.cantidad));
                this.montoIgvGlobal = this.montoValorUnitario2 * (this.$store.state.igv == 18 ? 0.18 : 0.105); //0.18
                item.precioVentaUnitario = this.montoValorUnitario2;
                item.cargosDescuentosItem[0].indicador= "descuento";
                (item.cargosDescuentosItem[0].codigoCargoDescuento= "00");
                (item.cargosDescuentosItem[0].factorCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento).toFixed(5)));
                item.cargosDescuentosItem[0].baseCargoDescuento = parseFloat(parseFloat(item.valorVentaSinAfectar).toFixed(2));
                item.cargosDescuentosItem[0].montoCargoDescuento = parseFloat(parseFloat(item.porcentajeDescuento * item.valorVentaSinAfectar).toFixed(2));
                }
            }
            }else{
                delete item.cargosDescuentosItem;
                item.cargosDescuentosItem = []
            }

            // tasaicbper = tasaicbper(this.fechaEmision) version futura
            tasabolsa = tasaicbper()
            // Impuestos a las bolsas plasticas
            if(this.icbper){
                item.precioVentaUnitario = parseFloat(this.precioVentaUnitario) + item.cantidad * tasabolsa
                item.afectoIcbper = this.icbper
                this.icbper = false
            }else{
                item.afectoIcbper = false
            }
            if(this.setIndex != -1){
                Object.assign(this.items[this.setIndex], item)
                this.$snotify.warning('Item Actualizado Correctamente', 'Atencion'),
                this.setIndex = -1
                this.setUpdateItem = false
                this.vbarras = false;
            }else{
                if(parseFloat(item.descuento) > parseFloat(item.valorUnitario * item.cantidad)){
                    this.$snotify.warning("El descuento no puede ser mayor al valor total por item","Cuidado");
                }else{
                    this.items.push(item)
                    this.vbarras = false;
                }
                if (this.items.length > 0) {
                    this.buttonRegularizacionAnticipos = false;
                }

                // this.items.push(item)
            }
            this.cantidad = 1
            this.codigoProducto = ''
            this.idProducto = '-'
            this.codigoTributo = ''
            this.tipoAfectacionIgv = ''
            this.descripcion = ''
            this.precioVentaUnitario = ''
            this.valorUnitario = ''
            this.codigoSunatBarras = ''
            this.codigoProductoGs1 = ''
            this.descuentoItemMonto = ''
            this.descuentoItemPorcentaje = ''
            this.descuento = false
            this.unidadMedidaCantidad = 'NIU'
            this.ventaGratuita = false
            item = {
                baseAfectacionIgv: '',
                adicional: {
                    indicardorDsct:'',
                    dsctSoles:'',
                    dsctPorcentaje:'',
                    precioVentaUni:'',
                    cargosDescuentosItem:[]
                }
            },
            this.sinresultados = false 
            this.gravado = false;
            this.sumaISC();
            if(this.itemEditado == false){
              this.actualizarItemsLista();
            }
        },
        actualizarItemsLista(){
            let codigo
            if(this.items.length > 0){
            this.items.forEach(element => {
                codigo = element.codigoProducto
            });
            }
            this.actualizarItem(codigo)
        },
        sumaISC(){
            let totalISC = 0.0;
            this.items.forEach(element => {
            if(element.iscOtrosTributosItem && element.iscOtrosTributosItem !=''){
                element.iscOtrosTributosItem.forEach(element => {
                totalISC += element.montoTributo
                });
            }
            });
            return totalISC
        },
        updateItem: function (index, itemUpdate) {
            this.itemEditado = true
            let itemChange = itemUpdate
            let item = {}
            this.setUpdateItem = true
            this.setIndex = index
            this.cantidad = itemChange.cantidad
            this.unidadMedidaCantidad = itemChange.unidadMedidaCantidad
            if(itemChange.codigoProducto != '' && itemChange.codigoProducto !='-' && itemChange.codigoProducto!= null){
                this.codigoProducto = itemChange.codigoProducto
            }
            if(itemChange.idProducto != '' && itemChange.idProducto != null){
                this.idProducto = itemChange.idProducto
            }else{
                this.idProducto = '-'
            }         
            if(itemChange.codigoProductoSunat && itemChange.codigoProductoSunat !=''){
                this.vbarras = false;
                this.codigoSunatBarras = itemChange.codigoProductoSunat;
            }else if(itemChange.codigoProductoGs1 !=''){
                this.vbarras = true;
                if(this.vbarras){
                    this.codigoProductoGs1 = itemChange.codigoProductoGs1
                }
            }
            this.descripcion = itemChange.descripcion
            if(itemChange.adicional && itemChange.adicional.precioVentaUni !=''){
                this.precioVentaUnitario = itemChange.adicional.precioVentaUni
            }else{
                 this.precioVentaUnitario = itemChange.precioVentaUnitario
            }

            this.valorUnitario = itemChange.valorUnitario

            if(itemChange.adicional && itemChange.adicional.indicardorDsct == '01'){
                this.descuentoItemMonto = itemChange.adicional.dsctSoles
            }else if(itemChange.adicional && itemChange.adicional.indicardorDsct == '02'){
                this.descuento = true
                this.descuentoItemPorcentaje = itemChange.adicional.dsctPorcentaje
            }else{
                this.descuentoItemMonto = ''
                this.descuentoItemPorcentaje = ''
            }   
            if(itemUpdate.tipoAfectacionIgv == "10"){
                this.especificacionIgv = '01'
            }else if(itemUpdate.tipoAfectacionIgv == "20"){
                this.especificacionIgv = '03'
            }else if(itemUpdate.tipoAfectacionIgv == "30"){
                this.especificacionIgv = '02'
            }
             //ISC
          if(itemChange.iscOtrosTributosItem){
            this.isc = true;
            this.cuadroISC = true;
            
            if(itemChange.iscOtrosTributosItem[0].tipoSistemaIsc == "01"){
              this.selectedISC = 1
              this.montoISC = itemChange.iscOtrosTributosItem[0].tasaTributo
            }else if(itemChange.iscOtrosTributosItem[0].tipoSistemaIsc == '02'){
              this.selectedISC = 2
              this.montoISC = itemChange.iscOtrosTributosItem[0].tasaTributo
            }else if(itemChange.iscOtrosTributosItem[0].tipoSistemaIsc == '03'){
              this.selectedISC = 3;
              this.montoISC = itemChange.iscOtrosTributosItem[0].baseTributo / (itemChange.cantidad)
              this.porcentajeISC = (itemChange.iscOtrosTributosItem[0].tasaTributo) ;
            }
          }
        },
        executeUpdate: function () {
            this.addItem()
        },
        sendBoletaAnticipos: function() {
            let desctglobal = {
            indicador: "",
            codigoCargoDescuento: "",
            factorCargoDescuento:"",
            montoCargoDescuento: "",
            baseCargoDescuento: ""
          }
        let valAnticipo = 0.0
        this.saveAnticipos.forEach(function(element){
           valAnticipo += element.montoAnticipado
        })
          let v1
          let v2
          let total
          this.valorAnticipo = parseFloat(valAnticipo / (this.$store.state.igv == 18 ? 1.18 : 1.105)); //1.18
              desctglobal.indicador = "descuento",
              desctglobal.codigoCargoDescuento = "04"
              desctglobal.factorCargoDescuento  = parseFloat((this.valorAnticipo / this.valortotal()).toFixed(5))        
              v1 = parseFloat((this.valorAnticipo / this.valortotal()).toFixed(5)) 
              desctglobal.baseCargoDescuento = parseFloat(this.valortotal().toFixed(2));
              v2 = parseFloat(this.valortotal().toFixed(2));
              total = v1*v2
              desctglobal.montoCargoDescuento = parseFloat(total.toFixed(2));
          this.cargosDescuentosGlobales.push(desctglobal)
          this.modalAnticipos = false;
        },
        addAnt: function(value, i) {
            let bufferAnticipo = {
            serieNumero: "",
            tipoComprobanteAnticipo: "",
            montoAnticipado: "",
            fechaPago: ""
            };
            if (
                    parseFloat(value.montoAnticipo) > 0 &&
                    parseFloat(value.montoAnticipo) <= parseFloat(value.montoRegularizar)
            ) {
            // Datos generales del item, uso en front
            if (value.compRegularizado != null) {
                bufferAnticipo.compRegularizado = value.compRegularizado;
            }
            if (value.created_at != null) {
                bufferAnticipo.created_at = value.created_at;
            }
            if (value.deleted_at != null) {
                bufferAnticipo.deleted_at = value.deleted_at;
            }
            bufferAnticipo.idAnticipo = value.idAnticipo;
            bufferAnticipo.idEmisor = value.idEmisor;
            bufferAnticipo.idReceptor = value.idReceptor;
            bufferAnticipo.montoRegularizar = value.montoRegularizar;
            bufferAnticipo.regularizado = value.regularizado;
            bufferAnticipo.serie = value.serie;
            bufferAnticipo.numero = value.numero;
            bufferAnticipo.tipoAfectacion = value.tipoAfectacion;
            bufferAnticipo.tipoComprobante = value.tipoComprobante;
            bufferAnticipo.updated_at = value.updated_at;
            // Datos para el Json Regularizacion de anticipos
            bufferAnticipo.serieNumero = value.serie + "-" + value.numero;
            bufferAnticipo.tipoComprobanteAnticipo = "03";
            bufferAnticipo.montoAnticipado = parseFloat(value.montoAnticipo);
            if (value.tipoAfectacion == 10) {
                bufferAnticipo.montoAnticipado = parseFloat(value.montoAnticipo);
                bufferAnticipo.montoAnticipadoValor =
                        parseFloat(value.montoAnticipo) / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
                bufferAnticipo.montoAnticipadoIgv =
                        parseFloat(value.montoAnticipo) -
                        parseFloat(value.montoAnticipo) / (this.$store.state.igv == 18 ? 1.18 : 1.105); //1.18
            }
            if (value.tipoAfectacion == 20) {
                bufferAnticipo.montoAnticipadoExonerado = parseFloat(
                        value.montoAnticipo
                );
            }
            if (value.tipoAfectacion == 30) {
                bufferAnticipo.montoAnticipadoInafecto = parseFloat(
                        value.montoAnticipo
                );
            }
            bufferAnticipo.fechaPago = this.$moment(value.created_at).format(
                    "YYYY-MM-DD"
            );
            this.selectedAnticipos.push(bufferAnticipo);
            this.docAnticipos.splice(i, 1);
            this.saveAnticipos = this.selectedAnticipos;
            } else if (value.montoAnticipado < 0) {
            this.$snotify.warning(
                    "El monto ingresado debe ser mayor a cero!",
                    "Atención"
            );
            } else if (
                    parseFloat(value.montoAnticipo) > parseFloat(value.montoRegularizar)
            ) {
            this.$snotify.warning(
                    "El monto anticipado no puede ser mayor al que va a regularizar",
                    "Atención"
            );
            } else {
            this.$snotify.warning("Valor invalido", "Atención");
            }
        },
        remAnt: function(item, i) {
            this.docAnticipos.push(item);
            this.selectedAnticipos.splice(i, 1);
            if(this.selectedAnticipos.length == 0){
                this.valGrabadaAnticipos = ''
            }
        },
        addAnticipos: function() {
            if(this.tipoDocumento == '0'){
                this.$snotify.warning("Debe seleccionar un tipo de documento", "Atención");
            }else{
                if (this.receptor.numero.length == 11 || this.receptor.numero.length == 8){
                    this.modalAnticipos = !this.modalAnticipos;
                    this.modalAnticipos = true;
                    this.disabledAnticipo = true;
                    this.switchAnticipo = false;
                    this.searchAnticipoByRuc();
                } else {
                    this.$snotify.warning("Debe ingresar el número del receptor", "Atención");
                }
            }
        },
        searchAnticipoByRuc(){
            let cantAnticipos = this.selectedAnticipos.length;
                if (cantAnticipos > 0) {
                    this.selectedAnticipos.splice(0, cantAnticipos);
                    this.valGrabadaAnticipos = ''
                }
                this.cargandoAnticipos = false
                axios
                .post(process.env.VUE_APP_API_URL + "anticipos/receptor",{
                    token: this.$store.getters.userToken,
                    idReceptor: this.receptor.numero,
                    page: this.currentPage,
                    limit: this.limite,
                    order: this.orden
                })
                .then(response =>(
                    this.docAnticipos = response.data.data,
                    this.total = response.data.total,
                    this.desde = response.data.from,
                    this.hasta = response.data.to,
                    this.cargandoAnticipos = true
                ))
                .catch(error =>(
                    this.cargandoAnticipos = false
                ))
        },
        loadListAnticipos: function() {
            let cantAnticipos = this.selectedAnticipos.length;
            if (cantAnticipos > 0) {
                this.selectedAnticipos.splice(0, cantAnticipos);
                this.valGrabadaAnticipos = ''
            }
            this.cargandoAnticipos = false;
            axios
            .post(process.env.VUE_APP_API_URL + "anticipos", {
                token: this.$store.getters.userToken,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
            })
            .then(response => (
                this.docAnticipos = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargandoAnticipos = true
            ))
            .catch(function(error) {
                this.cargandoAnticipos = false;
            });
        },
        accumulateAnticipos: function() {
            let val = 0.0;
            let valAnticiposValor = 0.0;
            let valAnticiposIgv = 0.0;
            this.selectedAnticipos.forEach(function(element) {
            if (element.tipoAfectacion == 10) {
                val += parseFloat(element.montoAnticipado);
                valAnticiposValor += parseFloat(element.montoAnticipadoValor);
                valAnticiposIgv += parseFloat(element.montoAnticipadoIgv);
            } else if (element.tipoAfectacion == 20) {
                val += parseFloat(element.montoAnticipadoExonerado);
            } else if (element.tipoAfectacion == 30) {
                val += parseFloat(element.montoAnticipadoInafecto);
            }
            });
            this.totalAnticipos = val;
            this.totalAnticiposValor = valAnticiposValor;
            this.totalAnticiposIgv = valAnticiposIgv;
            return val.toFixed(2);
        },
        validateRegularizacion: function() {
            if (this.selectedAnticipos.length > 0) {
                return false;
            } else {
                return true;
            }
        },
        deleteItem: function (index) {
            this.$swal({
                title: 'Eliminar Item',
                text: 'Seguro de eliminar este item ???',
                icon: 'error',
                buttons: true,
                dangerMode: true
            }).then((willDelete) => {
                if(willDelete){
                    this.items.splice(index,1)
                    if(this.items.length == 0){
                        this.buttonRegularizacionAnticipos = true;
                        this.disabledAnticipo = false;
                        this.descuentoItemMontoG = ''
                        this.listarMontos = []
                        this.valorGlobal = ''
                        this.cargosDescuentosGlobales = []
                    }
                    //this.item = {}
                }else{

                }
            })
        },
        addGuia: function () {
            let guias = {}
            guias.serie = this.seriedeguia,
            guias.numero = this.numerodeguia
            if(this.tipodeguia == '09'){
                guias.tipoGuia2 = 'Guia Remision Remitente'
            }
            else if(this.tipodeguia == '31'){
                guias.tipoGuia2 = 'Guia Remision Transportista'
            }
            guias.tipo = this.tipodeguia, 
            this.itemGuia.numero = this.seriedeguia + '-' + this.numerodeguia
            this.itemGuia.tipo = this.tipodeguia 
            this.items_guias.push(guias)
            this.guiasRelacionada.push(this.itemGuia)
            this.itemGuia = {}
            this.seriedeguia = ''
            this.numerodeguia = ''
            this.tipodeguia = '09'
        },
        deleteGuia: function (index) {
            this.items_guias.splice(index,1)
            this.guiasRelacionada.splice(index,1)
            this.seriedeguia = ''
            this.numerodeguia = ''
            this.tipodeguia = '09'
        }, 
        addAdicional: function () {
           this.itemAdicional.key = this.key
           this.itemAdicional.value = this.value
           this.items_adicionales.push(this.itemAdicional) 
           this.itemAdicional = {}
           this.key = ''
           this.value = ''
        },
        deleteAdicional: function (index) {
            this.items_adicionales.splice(index,1)
        },  
        getReceivers: function (value) {
            if(this.receptor.razonSocial !='' || this.receptor.numero.length >= 2){
            this.cargandoreceptor = true;
            this.listarec = true
            this.listaReceptores = []
            let link = ''
            let cadenabusqueda = ''
            if(value === 1){
                link = 'receptores/listaconterceros',
                cadenabusqueda = this.receptor.numero
            }else if(value === 2){  
                link = 'receptores/listaconterceros/razonsocial'
                cadenabusqueda = this.receptor.razonSocial
            }
            axios
            .post(process.env.VUE_APP_API_URL + link,{
                token: this.$store.getters.userToken,
                q: cadenabusqueda,
                tipoRec: this.tipoDocumento
            })
            .then(response => (
                this.filtroReceiver(response.data),
                this.cargandoreceptor = false,
                this.receivercount(this.listaReceptores.length)                     
            ))
            .catch(error => (
                this.cargandoreceptor = false
            ))
            }       
        },
        filtroReceiver: function (value) {
            if(value.idReceptor == '-'){
                this.tiporeceivers = false,
                this.listaReceptores = value
            }else{
                this.tiporeceivers = true,
                this.listaReceptores = value
            }
        },
        searchDNI(){
            this.cargandoreceptor = true
            axios
            .get(process.env.VUE_APP_API_URL +'v2/dni',{
                params:{
                    token: this.$store.getters.userToken,
                    dni: this.receptor.numero
                }
            })
            .then(response => (
                this.listadni = response.data,
                this.cargandoreceptor = false,
                this.receivedni(this.listadni)
            ))
            .catch(error => (
                this.cargandoreceptor = false,
                this.mostrardni = false
            ))    
            
        },
        receivedni: function (value){
            if(!value)
            {
                this.mostrardni = false
            }
            else
            {
                this.mostrardni = true,
                this.setReceiverdni(this.listadni)
            }
        },
        getReceiversProductCode: function (value) {
            if(value.length>=2){
               this.cargandoCodBarras = true
               this.listarecProduct = true
               this.norecProduct = false
               axios
                .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                    token: this.$store.getters.userToken,
                    filtro: 'code',
                    p: this.codigoProducto
                })
                .then(response => (
                    this.listaReceptoresProductCode = response.data.response,
                    this.cargandoCodBarras = false,
                    this.receivercountProduct(this.listaReceptoresProductCode.length)                                 
                ))
                .catch(error => (
                    this.cargandoCodBarras = false,
                    this.$snotify.error(error.response.data.msj, "Error")
                ))
            }  
        },
        getReceiversCodeBarrasSunat: function (value) {   
            let codSunat = '';     
            let receiver = ''
            if(this.vbarras){
                receiver = 'codegs1'
                 codSunat = this.codigoProductoGs1
            }else{
                receiver = 'codesunat'
                codSunat = this.codigoSunatBarras
            }
            if(value.length>1){
               this.cargandoBarrasSunat = true
               this.listarecProductBarrasSunat = true
               this.norecProductBarrasSunat = false
               axios
                .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                    token: this.$store.getters.userToken,
                     // 'name, code, codesunat, codegs1'
                     // Parametro ej: Shoes -> sho    
                    filtro: receiver,
                    p: codSunat
                })
                .then(response => (
                    this.listaReceptoresCodeBarrasSunat = response.data.response,
                    this.cargandoBarrasSunat = false,
                    this.receivercountBarrasSunat(this.listaReceptoresCodeBarrasSunat.length)                                 
                ))
                .catch(error => (
                    this.cargandoBarrasSunat = false
                ))
            }  
        },
            tecla(event){
            //  this.lastKeyPressed = event.key;
            if (event.keyCode === 13) {
            this.getReceiversDescription();
            return;
            }
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {this.getReceiversDescription();}, 1000);
        },
        actualizarItem(codigo){
            this.listades = false,
            this.cargandoInformacion = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'code',
                p: codigo
            })
            .then(response => (
                this.reciveArrayActualizado = response.data.response,
                this.cargandoInformacion = false,
                this.editarStockItem(this.reciveArrayActualizado)
            ))
            .catch(error => (
                this.cargandoInformacion = false,
                   console.log(error)
                ))
        },
        editarStockItem(array){
        this.items = this.items.map(item => {
          // Busca la actualización por el id del producto
        const actualizacion = array.find(act => act.idProducto === item.idProducto);
          // Si se encontró una actualización, actualiza el stock
          if (actualizacion) {
            item.stock = actualizacion.stock;
          }
          // Devuelve el item actualizado o sin cambios al array items
          return item;  
        });
      },
        getReceiversDescription: function () {
            let arrayNuevo = []
            this.listaDescription = []
            if(this.descripcion.length >=3){
                arrayNuevo = this.$store.getters.getTotalItems.filter(item => {
                // Verificar si la descripción del producto contiene el texto de búsqueda
                if(item && item.descripcion){
                  return item.descripcion.toLowerCase().includes(this.descripcion.toLowerCase());
                }
                });
                this.sinresultados = true, 
                this.cargandoDescription = true,
                this.listades = true,
                this.nodescription = false,

                this.listaDescription = arrayNuevo,
                this.cargandoDescription = false,
                this.sinresultados = false,
                this.cargandoreceptor = false,
                this.receivercountDescription(this.listaDescription.length),
                this.ordenarOpciones(this.listaDescription)
            }else{
                arrayNuevo = []
            }
            if (arrayNuevo.length === 0 && this.descripcion.length >= 4) {
                this.$snotify.warning('PRODUCTO NO ENCONTRADO')
            }     
        },
        ordenarOpciones: function(item) {
            this.opcionesOrdenadas = item.slice().sort((a, b) => {
                const lowerCaseDescripcionA = a.descripcion.toLowerCase();
                const lowerCaseDescripcionB = b.descripcion.toLowerCase();
                const lowerCaseSearch = this.descripcion.toLowerCase();

                const indexA = lowerCaseDescripcionA.indexOf(lowerCaseSearch);
                const indexB = lowerCaseDescripcionB.indexOf(lowerCaseSearch);
                // Si ambos tienen la misma cantidad de caracteres coincidentes,
                // ordenar por el índice en la descripción
                if (indexA === indexB) {
                    return indexA - indexB;
                }
                // Si tienen diferentes cantidades de caracteres coincidentes,
                // ordenar por la diferencia en la cantidad de caracteres
                if (indexA === 0) {
                    return -1; // a aparece primero
                } else if (indexB === 0) {
                    return 1; // b aparece primero
                } else if (indexA > 0 && indexB > 0) {
                    // Si ambos están después de la primera posición,
                    // ordenar por la posición
                    return indexA - indexB;
                } else {
                    // Si uno de ellos no contiene el término de búsqueda en la descripción,
                    // el que contiene la coincidencia aparece primero
                    return indexA < 0 ? 1 : -1;
                }
            });
        },
        menssageErrorDescripcion: function (value) {
            if(value.success == 0){
                this.$snotify.warning(value.msj, 'Atención')
            }
        },
        cerrarresultados: function () {
            this.listaDescription = [],
            this.listades = false
        },
        limpiarExcel(){
            this.postEmision = true,
            this.previwEmit = false,
            this.validarImporteTotal();
        },
        validarImporteTotal: function () {
            if(this.importeTotal >= 700 && this.tipoDocumento == '0'){
                this.$swal({
                title: 'Atención!!!',
                text: 'El importe total supera los 700 Soles, debe ingresa número de documento.',
                icon: 'warning',
                buttons: true,
                dangerMode: true
                }).then((willDelete) => {
                    
                })
            }else{
                this.sendTicket()
            }
        },
        sendTicket: function () {
            this.cargandoemision = true
            if(this.tipoOperacion =="0101EDU"){
                this.ticket.tipoOperacion = "0101"
            }else{
                this.ticket.tipoOperacion = this.tipoOperacion;
            }
            this.ticket.token = this.$store.getters.userToken
            this.ticket.receptor.tipo = this.tipoDocumento.toString()
            if(this.tipoDocumento == 0){
                this.ticket.receptor.nro = '-'
            }else{
                this.ticket.receptor.nro = this.receptor.numero.toString()
            }
            this.ticket.receptor.razonSocial = this.receptor.razonSocial
            this.ticket.receptor.direccion = this.receptor.direccion
            this.ticket.adicional.otroNombre = this.receptor.razonSocial
            if(this.typeTicket == 1){
                if(this.indexSerie == 0){
                    this.ticket.serie = this.listaSeries[0]
                }else{
                    this.ticket.serie = this.listaSeries[this.indexSerie]
                }
            }else{
                this.ticket.contingencia = this.contingencia
                this.ticket.serie = this.seriecon
                this.ticket.numero = this.numero
            }
            if(this.totalVentaGratuita > 0 && this.totalVentaGravada > 0){
                // Caso de Gratuitas combinadas con Gravadas
                this.ticket.totalValorVenta = this.totalVentaGravada;
                this.ticket.montoTotalImpuestos = this.montoTotalImpuestos
                this.ticket.totalVentaGratuita = this.totalVentaGratuita
                this.ticket.sumatoriaIgvGratuitas = this.sumatoriaIgvGratuitas
                this.ticket.totalVentaGravada = this.totalVentaGravada
                this.ticket.sumatoriaIgv = this.sumatoriaIgv
                this.ticket.totalVentaExonerada = this.totalVentaExonerada
                this.ticket.totalVentaInafecta = this.totalVentaInafecta
                this.ticket.totalVentaExportacion = this.totalVentaExportacion
                this.ticket.importeTotal = this.importeTotal
            }else if(this.totalVentaGratuita > 0 && this.totalVentaGravada == 0){
                // Caso de solo gratuitas
                this.ticket.montoTotalImpuestos = 0.00
                this.ticket.totalVentaGratuita = this.totalVentaGratuita
                this.ticket.sumatoriaIgvGratuitas = this.sumatoriaIgvGratuitas
                this.ticket.importeTotal = 0.00
            }
            if(this.descuentoItemMontoG !=''){
                this.ticket.cargosDescuentosGlobales = this.cargosDescuentosGlobales;
                // this.invoice.totalVentaGravada = this.muestra;
                this.ticket.totalValorVenta = this.totalVentaGravada
                this.ticket.totalPrecioVenta = this.importeTotal
            } 
            this.ticket.montoTotalImpuestos = this.montoTotalImpuestos
            this.ticket.sumatoriaIgv = this.sumatoriaIgv
            this.ticket.importeTotal = this.importeTotal
            if(this.selectedAnticipos.length > 0 && this.cotributo =='1000' ){
                this.ticket.totalVentaGravada = this.totalVentaGravada - this.valorAnticipo;
            }else{
                this.ticket.totalVentaGravada = this.totalVentaGravada
            }
            this.ticket.totalVentaExonerada = this.totalVentaExonerada2
            this.ticket.totalVentaInafecta = this.totalVentaInafecta2
            this.ticket.totalVentaExportacion = this.totalVentaExportacion
            this.ticket.guiasRelacionada = this.guiasRelacionada
            this.ticket.adicional.extras = this.items_adicionales
            this.ticket.adicional.totalDescuentoItem = this.totalDescuentosAcumulados
            this.ticket.adicional.dirAlternativa = this.receptor.direccion
            this.ticket.email = this.listaCorreos
            if(this.sumatoriaOtrosCargos > 0){
                // this.ticket.adicional.cargosGlobal = this.listaOtrosCargosAgregados
                this.ticket.cargosDescuentosGlobales = this.listaOtrosCargosAgregados
                this.ticket.sumatoriaOtrosCargos = this.sumatoriaOtrosCargos
            }
            if(this.selectedRetencion != null){
                this.ticket.cargosDescuentosGlobales = this.cargosDescuentosGlobales
            }
            if (this.selectedAnticipos.length > 0) {
                this.ticket.adicional.anticipos = this.selectedAnticipos;
                this.ticket.adicional.totalAnticipos = this.totalAnticipos;
                this.ticket.cargosDescuentosGlobales = this.cargosDescuentosGlobales;
            }else{
                delete this.ticket.adicional.anticipos;
                delete this.ticket.cargosDescuentosGlobales;
            }
            if(this.formadepago.codigo != '000'){
                if(this.formadepago.codigo === '00'){
                    this.ticket.credito = 1
                    this.ticket.adicional.credito = 1
                }else{
                    this.ticket.adicional.formaPago = this.formadepago.codigo
                    this.ticket.adicional.credito = 0
                }
            }
            if(this.femision != ''){
                this.ticket.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
            }
            if(this.fvencimiento != ''){
                this.ticket.adicional.fechaVencimiento = this.$moment(this.fvencimiento).format('YYYY-MM-DD')
            }
            // Total de icbper
            if(this.totalIcbper()>0){
                this.ticket.sumatoriaIcbper = this.totalIcbper()
            }else{
                delete this.ticket.sumatoriaIcbper
            }
                //isc
            if(this.sumaISC()>0){
            this.ticket.sumatoriaIsc = this.sumaISC()
            }
            this.ticket.adicional.ordenCompra = this.ordenCompra,
            this.ticket.adicional.username = this.$store.getters.userData.username
            this.ticket.adicional.tipo_igv = this.igvGlobal
            this.ticket.adicional.amazoniaSelva = this.$store.state.user.data.amazonia == 1 ? true : false;
            if(this.monederoPago == 1){
                this.ticket.monedero = 1
                this.ticket.nombreMonedero = "Yape"
            }else if(this.monederoPago == 2){
                this.ticket.monedero = 2
                this.ticket.nombreMonedero = "Plin"
            }else if(this.monederoPago == 3){
                this.ticket.monedero = 3
                this.ticket.nombreMonedero = "A Crédito"
            }else if(this.monederoPago == 4){
                this.ticket.monedero = 4
                this.ticket.nombreMonedero = "Tarjeta de Débito"
            }else if(this.monederoPago == 5){
                this.ticket.monedero = 5
                this.ticket.nombreMonedero = "Efectivo ventas menores  "
            }else if(this.monederoPago == 6){
                this.ticket.monedero = 6
                this.ticket.nombreMonedero = "Tarjeta de Crédito emitida en Perú"
            }else if(this.monederoPago == 7){
                this.ticket.monedero = 7
                this.ticket.nombreMonedero = "Depósito en cuenta"
            }else if(this.monederoPago == 8){
                this.ticket.monedero = 8
                this.ticket.nombreMonedero = "Transferencia de Fondos"
            }
            this.ticket.items = this.items,
            this.ticket.idOrdenPago = this.idOrdenPago
            this.ticket.tipoMoneda = this.moneda.codigo
            if (this.anticipo) {
                this.ticket.anticipo = true;
            }       
            axios
            .post(process.env.VUE_APP_API_URL + 'boletas/emitir', this.ticket)
            .then(response => (
                this.info = response.data,
                this.$snotify.success(response.data.msg, 'Éxito'),
                this.previwEmit = true,
                this.backEmision(this.info.response.idBoleta),
                this.initTicket()
            ))
            .catch(error => (
                this.previwEmit = true,
                this.cargandoemision = false,
                this.contingencia = false,
                this.ticketPrev.bandera = false,
                this.backEmision(0),
                this.catchError(error.response.data)
            ))
        },
        totalIcbper: function () {
            let total = 0
            this.items.forEach(function(element){
            if(element.afectoIcbper){
                total = total + (0.50 * element.cantidad)
            }
            })
            return total;
        },
        catchError: function (value) {
            let errorgateway = ''
            let errormessage = ''
            let errordescription = ''
            value.msg ? errorgateway = value.msg: errorgateway = ''
            value.response.message ? errormessage = value.response.message: errormessage = ''
            value.response.description ? errordescription = value.response.message: errordescription = ''
            // this.$snotify.error(errordescription + ' - ' + errormessage + ' - ' + errorgateway, 'Error')
            this.errorboleta = true;
            this.error1 = value.msg
            this.error2 = value.response.message
            this.error3 = value.response.description
        },
        initTicket: function () {
            this.cargandoemision = false,
            this.borraritem = true,
            this.receptor.numero = '',
            this.adicional.dirAlternativa = '',
            this.receptor.razonSocial = '',
            this.receptor.direccion = '',
            this.serie = '',
            this.seriecon = '',
            this.tipoDocumento = 0,
            this.ordenCompra = '',
            this.items_guias = [],
            this.guiasRelacionada = [],
            this.seriedeguia = '',
            this.numerodeguia = '',
            this.tipodeguia = '09',
            this.items_adicionales = [],
            this.key = '',
            this.value = '',
            this.typeTicket = 1,
            this.items = [],
            this.contingencia = false,
            this.selectedRetencion = null
            this.ticket = {
                tipoOperacion: '',
                serie: '',
                montoTotalImpuestos: 0.00,
                totalVentaGravada: 0.00,
                sumatoriaIgv: 0.00,
                importeTotal: 0.00,
                guiasRelacionada: [],
                adicional: {
                    totalDescuentoItem: '',
                    dirAlternativa: ''
                },
                items: [],
                receptor: {
                    tipo: '',
                    nro: '',
                    razonSocial: '',
                    direccion: ''
                }
            },
            this.action.reset = true
            this.accion.reset = true
            this.formadepago = {
                codigo: '008',
                nombre: 'Efectivo ventas menores'
            },
            this.sumatoriaOtrosCargos = 0,
            this.listaOtrosCargosAgregados = [],
            this.initMoneda(),
            this.file = null,
            this.guiasdoc = null,
            this.doc ="",
            this.buttonRegularizacionAnticipos = true;
            this.switchAnticipo = false;
            this.selectedAnticipos = [];
            this.valGrabadaAnticipos='';
            this.disabledAnticipo = false;
            this.docAnticipos = [];
            this.gravado = false,
            this.descuentoItemMontoG = '',
            this.listarMontos = [],
            this.valorGlobal = '',
            this.cargosDescuentosGlobales = [],
            this.itemsEX = [],
            this.aula = "",
            this.gradoYseccion = "",
            this.dniAlumno = "",
            this.nomApeAlumno = "",
            this.ubigeoOrigenDom = "", 
            this.direccionDomAlumno = "", 
            this.ubigeoDestinoDom = "", 
            this.direccionColegio = "", 
            this.periodoAcademido = ""
        },
        receivercount: function (value){
            if(!value)
            {   
                this.listarec = false
                 setTimeout(() => this.searchDNI(),1000);       
            }
            else
            {
                this.listarec = true
            }
        },
        receivercountProduct: function (value) {
            if(!value)
            {
                this.norecProduct = true
            }
            else
            {
                this.norecProduct = false
            }
        },
        receivercountBarrasSunat: function (value) {
            if(!value)
            {
                this.norecProductBarrasSunat = true
            }
            else
            {
                this.norecProductBarrasSunat = false
            }
        },
        receivercountDescription: function (value) {
            if(!value)
            {
                this.nodescription = true
            }
            else
            {
                this.nodescription = false
            }
        },
        customFormatter(date) {
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        changeTab: function (value){
            this.$emit("tabindex", value);
        },
        closeList(){
            this.listarec = false;
            this.tipoDocumento = 0;
            this.tiporeceivers = false;
            this.norecdni = false;
            this.mostrardni = false;

        },
        busquedaProductos(){
         this.searchItems = true
        },
        search(){
            this.mostrarListaProduc = true
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'name',
                p: this.descripcion
            })
            .then(response=>(
                this.ListProductos = response.data.response,
                this.ListProductos.forEach(function(element) {
                        element.cantidad = '',
                        element.boleta = 'boleta'
                    }),
                this.listaDescription = [],
                this.listades = false,
                this.mostrarListaProduc = false
            ))
            .catch(error=>(
               console.log(this.$snotify.warning("Debe agregar una descripción","Cuidado")),
               this.mostrarListaProduc = false
            ))      
        },
        searchCodigo(){ 
            let responseArray
            let merged
            this.mostrarListaProduc = true
            axios
            .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                token: this.$store.getters.userToken,
                filtro: 'code',
                p: this.codDescripcion  
            })
            .then(response=>(
                this.ListProductos = response.data.response,
                this.ListProductos.forEach(function(element) {
                        element.cantidad = ''
                        // element.boleta = 'boleta'
                    }),
                this.listaDescription = [],
                this.listades = false,
                this.mostrarListaProduc = false,
                responseArray = response.data.response,
                merged=(Object.assign({}, ...responseArray)),
                this.addUnidad(merged)
            ))
            .catch(error=>(
               console.log(this.$snotify.warning("Debe agregar una descripción","Cuidado")),
                this.mostrarListaProduc = false
            ))     
        },
        // reciveitem(data){
        //     let item = data
        //     let cantidad = data.cantidad
        //     if(this.validateCantidad(data)){
        //         if(cantidad == ''){
        //             item.cantidad = 1
        //             item.valorVenta = parseFloat(item.precioUnitario).toFixed(4)
        //             this.item = item
        //             this.action.b = true
        //         }else{
        //             // Insertar item con cantidad enviada por usuario 
        //             item.valorVenta = (parseFloat(cantidad)*parseFloat(item.precioUnitario)).toFixed(4)
        //             this.item = item
        //             this.action.b = true
        //         }   
        //     }
        //     if(this.items.length>0){
        //         this.action.reset = false
        //     }
        // },
        validateCantidad(data){
            if(parseFloat(data.cantidad) > 0 || data.cantidad == ''){
                return true
            }else{
                this.$snotify.warning('La cantidad debe ser mayor a cero','Cuidado')
                return false
            }
        },
        closeSearchItem(){
            this.searchItems = false
        },
        errorboletamodal(){
            this.errorboleta = false
        },
        cerrarModalSustentosGastos(){
            this.modalSustentaGastos = false;
        },
        pagosImg(valor){
        this.monederoPago = valor;
        valor == 1 ? this.colorPago1 = true : this.colorPago1 = false;
        valor == 2 ? this.colorPago2 = true : this.colorPago2 = false;
        valor == 3 ? this.colorPago3 = true : this.colorPago3 = false;
        valor == 4 ? this.colorPago4 = true : this.colorPago4 = false;
        valor == 5 ? this.colorPago5 = true : this.colorPago5 = false;
        valor == 6 ? this.colorPago6 = true : this.colorPago6 = false;
        valor == 7 ? this.colorPago7 = true : this.colorPago7 = false;
        valor == 8 ? this.colorPago8 = true : this.colorPago8 = false;
        if(valor == 1){
          this.formadepago.codigo = this.formaPago[3].codigo;
          this.formadepago.nombre = this.formaPago[3].nombre;
        }else if(valor == 2){
          this.formadepago.codigo = this.formaPago[3].codigo;
          this.formadepago.nombre = this.formaPago[3].nombre;
        }else if(valor == 3){
        //   this.formadepago.codigo = this.formaPago[1].codigo;
        //   this.formadepago.nombre = this.formaPago[1].nombre;
        //   this.modalCredito = true;
        }else if(valor == 4){
          this.formadepago.codigo = this.formaPago[5].codigo;
          this.formadepago.nombre = this.formaPago[5].nombre;
        }else if(valor == 5){
          this.formadepago.codigo = this.formaPago[8].codigo;
          this.formadepago.nombre = this.formaPago[8].nombre;
        }else if(valor == 6){
          this.formadepago.codigo = this.formaPago[6].codigo;
          this.formadepago.nombre = this.formaPago[6].nombre;
        }else if(valor == 7){
          this.formadepago.codigo = this.formaPago[1].codigo;
          this.formadepago.nombre = this.formaPago[1].nombre;
        }else if(valor == 8){
          this.formadepago.codigo = this.formaPago[3].codigo;
          this.formadepago.nombre = this.formaPago[3].nombre;
        }
      },
      send_message() {
        if(this.numeroWhatsApp && this.numeroWhatsApp.trim() !== ''){
            if(this.numeroWhatsApp.length == 9){
                const url = 'https://micomprobante.facturaonline.pe/s/pkey-'
                const {
                    idEmisor,
                    serie,
                    numero,
                    idReceptor,
                    importeTotal
                } = this.dataImpresion
                let boleta = '03';
                const mensaje = 'Comprobante' + ' ' + this.dataImpresion.serie +'-'+ this.dataImpresion.numero + ' ' + 'Emitido a través de TELEMOVILPERU.COM'
                const cadena = `${idEmisor}|${boleta}|${serie}|${numero}|${idReceptor}|${importeTotal}`
                const text = `${url}.${btoa(cadena)}+${mensaje}`
                window.open(`https://wa.me/+51${this.numeroWhatsApp}?text=${text}`, '_blank')
            }else{
                this.$snotify.warning("DEBE INGRESAR 9 DIGITOS")
            }
        }else{
            this.$snotify.warning("DEBE INGRESAR INFORMACION")
        }
    },
    ubigeoOrigenDomicilio(){
        this.modalUbigeoOrigen = true;
      },
    searchDistrictOrigen: function (value, ind) {
        let departmentActual = ''
        let provinceActual = ''
        if(ind == 1){
          departmentActual = this.departamentoSeleccionadoUbigeoOrigen,
          provinceActual = this.provinciaSeleccionadaUbigeoOrigen,
          this.distOrigenCargando = value
        }else if(ind == 2){
 
        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
            token: this.$store.getters.userToken,
            department: departmentActual,
            province: provinceActual
        })
        .then(response => (
            this.listDistrictOrigen = response.data,
            this.distOrigenCargando = false
        ))
        .catch(error => {})
      },
      searchProvinceOrigen: function (ind) {
        let departamentoActual = ''
        if(ind == 1){
            departamentoActual = this.departamentoSeleccionadoUbigeoOrigen
            this.provOrigenCargando = true
        }else if(ind == 2){
          
        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
            token: this.$store.getters.userToken,
            department: departamentoActual
        })
        .then(response => (
            this.listProvinceOrigen = response.data,
            this.provOrigenCargando = false                     
        ))
        .catch(error => {})
      },
      searchProvinceDestino: function (ind) {
        let departamentoActual = ''
        if(ind == 1){
            departamentoActual = this.departamentoSeleccionadoUbigeoDestino,
            this.provDestinoCargando = true
        }else if(ind == 2){
        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
            token: this.$store.getters.userToken,
            department: departamentoActual
        })
        .then(response => (
            this.listProvinceDestino = response.data,
            this.provDestinoCargando = false                  
        ))
        .catch(error => {})
      },
      searchDistrictDestino: function (value, ind) { 
        let departmentActual = ''
        let provinceActual = ''
        if(ind == 1){
          departmentActual = this.departamentoSeleccionadoUbigeoDestino,
          provinceActual = this.provinciaSeleccionadaUbigeoDestino,
          this.distDestinoCargando = value
        }else if(ind == 2){

        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
            token: this.$store.getters.userToken,
            department: departmentActual,
            province: provinceActual
        })
        .then(response => (
            this.listDistrictDestino = response.data,
            this.distDestinoCargando = false 
        ))
        .catch(error => {})
      },
    }
}
</script>

<style scoped>
    .input-requerido::placeholder {
        color:#DB0000;
        opacity: 1;
    }
    .searcher-field{
        z-index: 1000;
        position: absolute;
        max-height: 500px !important;
        overflow-y: scroll;
        width: 900px
    }
    .searcher-result{
        font-size: 1em;
        padding: 5px;
        cursor: pointer;
    }
    .sinresultados{
        padding: 0 5px 0 5px;  
    }
    .searchItem{
        background-color: #F0E1F6;
        border-color: #F0E1F6;
        color: #9C53E0;
    }
    .acciones-espacio {
        margin-right: 10px;
    }
    .input-placedark::placeholder {
    color:#353333;
    opacity: 0.9;
    }
    .input-dark{
        color:#000000;
        opacity: 1;
    }
    .sinresultados2{
        padding: 0 10px 0 10px;
    }
    .titulo-opitem{
        padding-left: 30%;
    }
    .buttonagregar{
        padding-left: 200px;
        margin-top: -18px;
    }
    .mover{
        margin-top: -18px; 
    }
    .botondescuento {
        margin-left: -5px;
        margin-top: 5px;
    }
    .alineacionTotales{
        margin-right: 50%;
        text-align: right;
    }
    .bajarunpoco{
        margin-top: 15%;
    }
    .monedaOtrosCargos{
        margin-top: -55px;
    }
    .monedaTotales{
        margin-top: 47%;
    }
    .cajatotales{
        margin-top: 4%;
        margin-left: -50%;
    }
    .colorestelemovil{
        background-color: #006eae;
        color: #ffffff;
    }
    .tooltipNew{
        background-color: green;
    }
    .centerpreview{
        text-align: center;
    }
    .estilospreview{
        color: #FC7E00;
    }
    .botonesemitirBoleta{
        width: 80px;
        margin-left: 15px;
    }
    .btnagregarstyle{
        width: 325px;
    }
    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }

    .estilo {
        border: 2px solid teal;
        color: white;
        background-color: teal;
        padding: 8px 20px;
        border-radius: 5px;
        font-weight: bold;
    }

    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }
    .agregaritemsnew2 {
        margin-top: 5px;
        width: 100%;
        margin-left: 4px;
    }
    .bordesAnticipos {
        border: 1px solid #ccc;
    }
    .lianticipo {
        list-style: none;
    }
    /* inputs */
    .borde{
        width: 30%;
        border: none;
        border-bottom: solid 1px;
    }
    .lab{
        display: inline-block;
        background-color: teal;
        color: white;
        padding: 0.5rem;
        border-radius: 0.3rem;
        cursor: pointer;
        margin-left: 10px;
    }
    .formasPagosImg{
        width: 60%;
        height: 40%;
        border-radius: 25px;
        cursor: pointer;
    }
  .searcher-result2 {
        background-color: white;
        font-size: 1em;
        cursor: pointer;
    }
    .searcher-result2 :hover{
        background-color:skyblue;
        border:1px solid grey
    }
    .searcher-result3{
        background-color: white;
    } 
    .colorBorde{
        border-color:#7e8fb9;
    }
    .tablaborde{
        border: 1px solid #B8cdd5;
    }
    .centrarTitulo{
        text-align: center;
    }

</style>

